/*
 * @Author: 侯鹏许(houpengxu@qq.com)
 * @Date: 2019-08-14 17:21:33
 * @LastEditors: Do not edit
 * @LastEditTime: 2022-04-23 14:34:56
 * @Description: file content
 */
/**
 * Created by pengxu on 2017/6/23.
 * 180814二次授权
 */

/**
 * config
 */
window.cfg = {
  isLoc: location.href.indexOf("localhost") > -1 ? true : false,
  isTest: false,
  helpShowWx: 0,
  apihost: /\.(com|net|org|cn)$/i.test(location.hostname)
    ? (location.hostname.substring(0, location.hostname.indexOf(".")) + ".ttrushi.com") : 'cqwkh.ttrushi.com',
  subdomian: '',
  isWxworkBase: location.host.indexOf('rstest.') > -1 || location.host.indexOf('gjzsyyyz.') > -1
}
if (location.host == "qywx.ruthus.com") {
  window.cfg.apihost = 'qmyx.ttrushi.com';
}

if (location.host == "cloudwebtest.circlemartech.com") {
  window.cfg.apihost = 'rstest.ttrushi.com';
}

if (location.host == "cloudweb.circlemartech.com") {
  window.cfg.apihost = 'gjzyxzj.ttrushi.com';
}

function localOpenid() {
  if (cfg.isLoc) {
    let url = location.href;
    let tmpObj = {};
    let tmpArr = url.split("?");
    if (tmpArr.length == 2) {
      let urlParam = tmpArr[1];
      let tmpArr1 = urlParam.split('&');
      tmpArr1 = tmpArr1.map(function (e) {
        tmpObj[e.split('=')[0]] = e.split('=')[1];
      })
    }
    if (tmpObj.fake) {
      cfg.apihost = tmpObj.fake.split("_")[0] + ".ttrushi.com";
    } else {
      alert("没有fake参数")
    }
  }
}
localOpenid();

cfg.isTest = (cfg.apihost.indexOf("qmyx.") > -1 || cfg.apihost.indexOf("sjzstest.") > -1 || cfg.apihost.indexOf("rstest.") > -1 || cfg.apihost.indexOf("cartest.") > -1) ? true : false;

if (cfg.isTest) {
  yqAnalytics.init({
    env: "test",
    appId: "b7b0f945a5fd4ab197eb77f4743c09aa",
  });
} else {
  yqAnalytics.init({
    appId: "82d2ff334d404f6c914b4fe8e68f4008",
  });
}

window.initWXJSSDK = function (plugFun) {
  if (!myTemp.openid) {
    return;
  }
  var shareLink = `${location.protocol}//${location.host}/h5/t1.html?id=${myPageData.PageId}`;
  var shareTitle = myPageData.WxShare && (myPageData.WxShare.Title || myPageData.BrowserTabTitle);
  var shareDesc = myPageData.WxShare && (myPageData.WxShare.Description || myPageData.BrowserTabTitle);
  var shareImg = myPageData.WxShare && myPageData.WxShare.FilePath;

  var usercard2_masteropenid = wj.cookie.get("usercard2_masteropenid");
  if (usercard2_masteropenid && false) {
    $.ajax({
      type: "GET",
      url: api.wx,
      async: false,
      data: {
        j: JSON.stringify({
          "action": "/hb/HbUserAction/fansInfo",
          "requestParam": {
            obj: {
              openid: usercard2_masteropenid
            }
          },
          "openid": myTemp.openid,
          "passport": myTemp.passport,
          "url": location.href
        })
      },
      success: function (data) {
        var cardinfo = data.obj;
        var myhost = location.host.indexOf("localhost") > -1 ? "qmyx.rushinews.com" : location.host;
        shareLink = `http://${myhost}/h5/usercard2.html?openid=${cardinfo.openid}&refereeopenid=${myTemp.openid}`;

        shareTitle = `我是${cardinfo.gappname || cardinfo.projectname}的${cardinfo.ui_name || cardinfo.name || cardinfo.nickname}，欢迎您随时联系`;
        shareDesc = `手机号：${cardinfo.ui_mobile || cardinfo.mobile}${cardinfo.ui_weixin ? "微信号：" + cardinfo.ui_weixin : ""}`;
        shareImg = cardinfo.headimgurl;
      }
    });
  }
  if (myTemp.psn) {
    shareLink += "&psn=" + myTemp.psn;
  }
  shareLink += "&refereeopenid=" + myTemp.openid;
  if (myTemp.rscuid) {
    shareLink += "&rscuid=" + myTemp.rscuid;
  }
  if (myTemp.isWxworkGroupMsg) {
    shareLink += "&corpId=" + myTemp.corpId;
    shareLink += "&qwUserId=" + myTemp.qwUserId;
    shareLink += "&batchId=" + myTemp.batchId;
  }
  shareLink = wj.addUrlParamFromObj(shareLink, {
    tt: new Date().getTime()
  })
  if (myTemp.share_api) {
    shareLink = myTemp.share_api.replace("{desturl}", encodeURIComponent(shareLink));
  }
  if (plugFun) {
    shareLink = plugFun();
  }

  var tmpUrl2047 = api.wx;
  if (location.host.indexOf("fqjzw.") > -1 || location.host.indexOf("qdpdats.") > -1 || location.host.indexOf("yqjisu.") > -1 || location.host.indexOf("zyljxyf.") > -1
    || location.host.indexOf("jsby.") > -1
    || location.host.indexOf("xzsklf.") > -1) {
    tmpUrl2047 = location.protocol + "//shjinbao.ttrushi.com/qc-webapp/wxapi.do";
  } else if (location.host.indexOf("jxwk.") > -1 || location.host.indexOf("zhzy.") > -1 || location.host.indexOf("zagbgn.") > -1) {
    tmpUrl2047 = location.protocol + "//yunmeiha.ttrushi.com/qc-webapp/wxapi.do";
  } else if (location.host.indexOf("rdjt.") > -1 || location.host.indexOf("shhxbst.") > -1) {
    tmpUrl2047 = location.protocol + "//lsdyb.ttrushi.com/qc-webapp/wxapi.do";
  } else if (location.host.indexOf("wlcbinh.") > -1 || location.host.indexOf("hllsq.") > -1 || location.host.indexOf("qcbdt.") > -1) {
    tmpUrl2047 = location.protocol + "//haopanyu.ttrushi.com/qc-webapp/wxapi.do";
  } else if (location.host.indexOf("hdlyzsx.") > -1 || location.host.indexOf("lxfdcwxq.") > -1) {
    tmpUrl2047 = location.protocol + "//yuanquan.ttrushi.com/qc-webapp/wxapi.do";
  } else if (location.host.indexOf("baolong.") > -1 || location.host.indexOf("hyhtd.") > -1 || location.host.indexOf("tlyqlydj.") > -1) {
    tmpUrl2047 = location.protocol + "//loupany.ttrushi.com/qc-webapp/wxapi.do";
  } else if (location.host.indexOf("hxdcj.") > -1) {
    tmpUrl2047 = location.protocol + "//yqkjw.ttrushi.com/qc-webapp/wxapi.do";
  } else if (location.host.indexOf("hsmjztjz.") > -1 || location.host.indexOf("dljdpp.") > -1) {
    tmpUrl2047 = location.protocol + "//yuanqua.ttrushi.com/qc-webapp/wxapi.do";
  } else if (location.host.indexOf("hjzjkwg.") > -1) {
    tmpUrl2047 = location.protocol + "//yyqq.ttrushi.com/qc-webapp/wxapi.do";
  } else if (location.host.indexOf("djdcfwh.") > -1 || location.host.indexOf("hbjd.") > -1 || location.host.indexOf("yqkjjbq.") > -1) {
    tmpUrl2047 = location.protocol + "//vretk.ttrushi.com/qc-webapp/wxapi.do";
  }

  $.ajax({
    type: "GET",
    url: tmpUrl2047,
    data: {
      j: JSON.stringify({
        openid: location.host.indexOf("fqjzw.") > -1 ? 'oPg9r1Smqfm7L0xRQg31bv3QEurM' : myTemp.openid,
        passport: location.host.indexOf("fqjzw.") > -1 ? 'b6ea31a39077f68fb85ba41109f51b40' : myTemp.passport,
        "vericode": "",
        "url": location.href,
        "action": "getAppid",
        "requestParam": {}
      }),
      t: 6
    },
    success: function (data) {
      if (data.code < 0) {
        return;
      }
      wx.config({
        debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
        appId: data.obj, // 必填，公众号的唯一标识
        timestamp: data.jsParams.timestamp, // 必填，生成签名的时间戳
        nonceStr: data.jsParams.noncestr, // 必填，生成签名的随机串
        signature: data.jsParams.signature, // 必填，签名，见附录1
        jsApiList: [
          'checkJsApi',
          'updateTimelineShareData',
          'updateAppMessageShareData',
          'onMenuShareTimeline',
          'onMenuShareAppMessage',
          'onMenuShareQQ',
          'onMenuShareWeibo',
          'onMenuShareQZone',
          'getLocation',
          'openLocation'
        ], // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
        openTagList: [
          'wx-open-launch-weapp',
          'wx-open-launch-app'
        ] // 可选，需要使用的开放标签列表，例如['wx-open-launch-app']
      });
      if (!myPageData.WxShare) {
        return;
      }
      window.shareLink = shareLink
      wx.ready(function () {
        window.ContentSelfAudio = new Audio();
        window.ContentSelfAudio.src =
          "https://assets.rurushishi.com/sharelib/iPhone.mp3";

        if (location.host.indexOf("ldjthczy.") > -1) {
          if (myPageData.PageId == 64174) {

          } else {
            wx.updateTimelineShareData({
              title: shareTitle,
              link: shareLink,
              imgUrl: shareImg,
              success: function () {

              },
              cancel: function () {

              }
            });

            wx.updateAppMessageShareData({
              title: shareTitle,
              desc: shareDesc,
              link: shareLink,
              imgUrl: shareImg,
              type: '',
              dataUrl: '',
              success: function () {

              },
              cancel: function () {

              }
            });
          }
        }


        wx.onMenuShareTimeline({
          title: shareTitle,
          link: shareLink,
          imgUrl: shareImg,
          success: function () {
            setTimeout(function () {
              wxShare();
            }, 500);
          },
          cancel: function () {

          }
        });


        wx.onMenuShareAppMessage({
          title: shareTitle,
          desc: shareDesc,
          link: shareLink,
          imgUrl: shareImg,
          type: '',
          dataUrl: '',
          success: function () {

            wxShare();
          },
          cancel: function () {

          }
        });


        wx.onMenuShareQQ({
          title: shareTitle,
          desc: shareDesc,
          link: shareLink,
          imgUrl: shareImg,
          success: function () {

            wxShare();
          },
          cancel: function () {

          }
        });

        wx.onMenuShareWeibo({
          title: shareTitle,
          desc: shareDesc,
          link: shareLink,
          imgUrl: shareImg,
          success: function () {

            wxShare();
          },
          cancel: function () {

          }
        });

        wx.onMenuShareQZone({
          title: shareTitle,
          desc: shareDesc,
          link: shareLink,
          imgUrl: shareImg,
          success: function () {

            wxShare();
          },
          cancel: function () {

          }
        });


        if (myPageData.Opengps) {
          wx.getLocation({
            type: 'gcj02', // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
            success: function (res) {
              myTemp.gcj02 = res;
              var latitude = res.latitude; // 纬度，浮点数，范围为90 ~ -90
              var longitude = res.longitude; // 经度，浮点数，范围为180 ~ -180。
              var speed = res.speed; // 速度，以米/每秒计
              var accuracy = res.accuracy; // 位置精度
              // alert(`维度${latitude} 经度${longitude} 速度${speed} 精度${accuracy}`)
              uploadLocation(latitude, longitude, speed, accuracy);
              biz.handlerYqAnalyticsEvent('authLocation')
            }
          });
        }
      });
    }
  });
}

cfg.subdomian = cfg.apihost.substring(0, cfg.apihost.indexOf("."));
if (cfg.isLoc) {
  var contentType = 1;
  if (contentType == 1) {
    //多图形式
  } else if (contentType == 2) {
    //图文形式
  } else if (contentType == 3) {
    //视频形式
  } else if (contentType == 4) {
    //微信形式
  }
}
window.api = {
  h5: location.protocol + "//" + cfg.apihost + "/qc-webapp/h5count.do?",
  wx: location.protocol + "//" + cfg.apihost + "/qc-webapp/wxapi.do",
  wxQcwebapp: location.protocol + "//" + cfg.apihost + "/qc-webapp"
}


/**
 * defined function
 */
window.wj = {
  clientW: document.documentElement.clientWidth,
  clientH: document.documentElement.clientHeight,
  qs: function (name, isDecodeURI) {
    var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
    var r = window.location.search.substr(1).match(reg);
    if (r != null) {
      if (isDecodeURI)
        return decodeURI(r[2]);
      return r[2];
    }
    return null;
  },
  browser: {
    info: navigator.appVersion,
    versions: function () {
      var u = navigator.userAgent,
        app = navigator.appVersion;
      return {
        trident: u.indexOf('Trident') > -1,
        presto: u.indexOf('Presto') > -1,
        webKit: u.indexOf('AppleWebKit') > -1,
        gecko: u.indexOf('Gecko') > -1 && u.indexOf('KHTML') == -1,
        mobile: !!u.match(/AppleWebKit.*Mobile.*/) || !!u.match(/AppleWebKit/),
        ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/),
        android: u.indexOf('Android') > -1 || u.indexOf('Linux') > -1,
        iPhone: u.indexOf('iPhone') > -1 || u.indexOf('Mac') > -1,
        iPad: u.indexOf('iPad') > -1,
        webApp: u.indexOf('Safari') == -1,
        wxGroup: u.toLowerCase().match(/MicroMessenger/i) == 'micromessenger',
        wx: u.toLowerCase().match(/MicroMessenger/i) == 'micromessenger' && u.match(/wxwork/i) != 'wxwork',
        dy: u.toLowerCase().match(/toutiaomicroapp/i) == 'toutiaomicroapp',
        wxwork: u.match(/wxwork/i) == 'wxwork'
      };
    }()
  },
  isMobileNumber: function (mobile) {
    var b1 = /^1[3-9]\d{9}$/.test(String(mobile).replace(/^0+/g, ''));
    var b2 = /^0\d{2,3}-?\d{7,8}$/.test(mobile);
    var b3 = false;
    if (returnCitySN && returnCitySN.cname) {
      if (!/[\u4e00-\u9fa5]+/.test(returnCitySN.cname)) {
        b3 = /^[' '|+|-|a|\d]{5,20}$/.test(mobile);
      }
    }
    return b1 || b2 || b3;
  },
  isNumber: function (str) {
    return /^[1-9]+[0-9]*]*$/.test(str);
  },
  loadImgs: function (urls, progressCallback, completeCallback) {
    var myInterVal = null;
    var imgs = [],
      index = 0,
      _load = function _load() {
        var img = new Image;
        img.src = urls[index], img.onload = function () {
          imgs.push(img);
          if (progressCallback) {
            progressCallback();
          }
          index++;
          if (index / urls.length == 1) {
            completeCallback();
          } else {
            _load();
          }
        }
      };
    _load();
  },
  loadAudio: function (src, callback) {
    var audio = new Audio(src);
    audio.onloadedmetadata = callback;
    audio.src = src;
  },
  cookie: {
    set: function (key, val, second, domain) {//设置cookie方法，秒过期
      var date = new Date(); //获取当前时间
      date.setTime(date.getTime() + second * 1000); //格式化为cookie识别的时间
      var cookieVal = key + "=" + val + ";path=/;expires=" + date.toGMTString() + (domain ? (";domain=" + domain) : "");  //设置cookie
      document.cookie = cookieVal;
    },
    get: function (key) { //获取cookie方法
      /*获取cookie参数*/
      var getCookie = document.cookie.replace(/[ ]/g, ""); //获取cookie，并且将获得的cookie格式化，去掉空格字符
      var arrCookie = getCookie.split(";") //将获得的cookie以"分号"为标识 将cookie保存到arrCookie的数组中
      var tips = ""; //声明变量tips
      for (var i = 0; i < arrCookie.length; i++) { //使用for循环查找cookie中的tips变量
        var arr = arrCookie[i].split("="); //将单条cookie用"等号"为标识，将单条cookie保存为arr数组
        if (key == arr[0]) { //匹配变量名称，其中arr[0]是指的cookie名称，如果该条变量为tips则执行判断语句中的赋值操作
          tips = arr[1]; //将cookie的值赋给变量tips
          break; //终止for循环遍历
        }
      }
      return tips;
    },
    delete: function (key) { //删除cookie方法
      var date = new Date(); //获取当前时间
      date.setTime(date.getTime() - 10000); //将date设置为过去的时间
      document.cookie = key + "=v; expires =" + date.toGMTString(); //设置cookie
    }
  },
  clientInfo: (function () {
    var attrs = [
      "appCodeName", "appName", "appVersion", "cookieEnabled", "language", "platform", "product", "vendor"
    ];
    var str = "";
    attrs.forEach(function (e, i) {
      str += e + ":" + navigator[e] + ";";
    })
    return str;
  })(),
  formatDateLikeWx: function (dateTime) {
    //2017-12-25 15:57:50
    //原始时间
    var strOrgDateTime = "2017-12-24 12:57:50";
    strOrgDateTime = dateTime;
    var orgObj = {
      yy: strOrgDateTime.substring(0, 4),
      mm: strOrgDateTime.substring(5, 7),
      dd: strOrgDateTime.substring(8, 10),
      h: strOrgDateTime.substring(11, 13),
      m: strOrgDateTime.substring(14, 16),
      s: strOrgDateTime.substring(17, 19),
    };
    //当前时间
    var strNowDateTime = wj.getFullTime(new Date());
    var nowObj = {
      yy: strNowDateTime.substring(0, 4),
      mm: strNowDateTime.substring(5, 7),
      dd: strNowDateTime.substring(8, 10),
      h: strNowDateTime.substring(11, 13),
      m: strNowDateTime.substring(14, 16),
      s: strNowDateTime.substring(17, 19),
    };
    var date1 = new Date(strOrgDateTime); //开始时间
    var date2 = new Date(strNowDateTime); //结束时间
    var date3 = date2.getTime() - date1.getTime(); //时间差的毫秒数
    //计算出相差天数
    var days = Math.floor(date3 / (24 * 3600 * 1000));
    //计算出小时数
    var leave1 = date3 % (24 * 3600 * 1000); //计算天数后剩余的毫秒数
    var hours = Math.floor(leave1 / (3600 * 1000));
    //计算相差分钟数
    var leave2 = leave1 % (3600 * 1000); //计算小时数后剩余的毫秒数
    var minutes = Math.floor(leave2 / (60 * 1000));
    //计算相差秒数
    var leave3 = leave2 % (60 * 1000); //计算分钟数后剩余的毫秒数
    var seconds = Math.round(leave3 / 1000);


    var newStr = "";
    if (leave2 < 60) {
      if (leave2 <= 0) {
        newStr = "刚刚"
      } else {
        newStr = leave2 + "分钟前";
      }
    } else if (leave1 < 24) {
      newStr = leave1 + "小时前";
    } else if (parseInt(orgObj.h) >= 0 && parseInt(orgObj.h) <= 5) {
      newStr = "凌晨" + orgObj.h + ":" + orgObj.m;
    } else if (parseInt(orgObj.h) >= 6 && parseInt(orgObj.h) <= 10) {
      newStr = "上午" + orgObj.h + ":" + orgObj.m;
    } else if (parseInt(orgObj.h) >= 11 && parseInt(orgObj.h) <= 13) {
      newStr = "中午" + orgObj.h + ":" + orgObj.m;
    } else if (parseInt(orgObj.h) >= 14 && parseInt(orgObj.h) <= 17) {
      newStr = "下午" + orgObj.h + ":" + orgObj.m;
    } else if (parseInt(orgObj.h) >= 18 && parseInt(orgObj.h) <= 23) {
      newStr = "晚上" + orgObj.h + ":" + orgObj.m;
    } else {
      newStr = orgObj.h + ":" + orgObj.m;
    }

    if (days == 1) {
      //昨天
      newStr = "昨天 " + newStr;
    } else if (wj.isSameWeek(new Date(date1.setDate(date1.getDate() - 1)), new Date(date2))) {
      //同一周
      var weeks = ['周日', '周一', '周二', '周三', '周四', '周五', '周六'];
      newStr = weeks[date1.getDay() + 1] + " " + newStr;
    } else if (nowObj.yy == orgObj.yy) {
      //同一年
      newStr = orgObj.mm + "月" + orgObj.dd + "日 " + newStr;
    } else {
      newStr = orgObj.yy + "年" + orgObj.mm + "月" + orgObj.dd + "日 " + newStr;
    }

    return newStr;
  },
  getFullTime: function (time) {
    var date = new Date(time);
    var m = date.getMonth() + 1;
    m <= 9 ? m = '0' + m : m;
    var d = date.getDate();
    d <= 9 ? d = '0' + d : d;
    var h = date.getHours();
    h <= 9 ? h = '0' + h : h;
    var m2 = date.getMinutes();
    m2 <= 9 ? m2 = '0' + m2 : m2;
    var s = date.getSeconds();
    s <= 9 ? s = '0' + s : s;
    return date.getFullYear() + '-' + m + '-' + d + ' ' + h + ':' + m2 + ':' + s;
  },
  isSameWeek: function (old, now) {
    var oneDayTime = 1000 * 60 * 60 * 24;
    var old_count = parseInt(old.getTime() / oneDayTime);
    var now_other = parseInt(now.getTime() / oneDayTime);
    return parseInt((old_count + 4) / 7) == parseInt((now_other + 4) / 7);
  },
  isSameThehour: function (org, now) {

    var strOrgDateTime = org;
    var orgObj = {
      yy: strOrgDateTime.substring(0, 4),
      mm: strOrgDateTime.substring(5, 7),
      dd: strOrgDateTime.substring(8, 10),
      h: strOrgDateTime.substring(11, 13),
      m: strOrgDateTime.substring(14, 16),
      s: strOrgDateTime.substring(17, 19),
    };
    //当前时间
    var strNowDateTime = now;
    var nowObj = {
      yy: strNowDateTime.substring(0, 4),
      mm: strNowDateTime.substring(5, 7),
      dd: strNowDateTime.substring(8, 10),
      h: strNowDateTime.substring(11, 13),
      m: strNowDateTime.substring(14, 16),
      s: strNowDateTime.substring(17, 19),
    };
    var newStr = false;
    if (parseInt(orgObj.h) >= 0 && parseInt(orgObj.h) <= 5 && parseInt(nowObj.h) >= 0 && parseInt(nowObj.h) <= 5) {
      newStr = true;
    } else if (parseInt(orgObj.h) >= 6 && parseInt(orgObj.h) <= 10 && parseInt(nowObj.h) >= 6 && parseInt(nowObj.h) <= 10) {
      newStr = true;
    } else if (parseInt(orgObj.h) >= 11 && parseInt(orgObj.h) <= 13 && parseInt(nowObj.h) >= 11 && parseInt(nowObj.h) <= 13) {
      newStr = true;
    } else if (parseInt(orgObj.h) >= 14 && parseInt(orgObj.h) <= 17 && parseInt(nowObj.h) >= 14 && parseInt(nowObj.h) <= 17) {
      newStr = true;
    } else if (parseInt(orgObj.h) >= 18 && parseInt(orgObj.h) <= 23 && parseInt(nowObj.h) >= 18 && parseInt(nowObj.h) <= 23) {
      newStr = true;
    }
    return newStr;
  },
  changeTitle: function (title) {
    if (wj.browser.versions.wxGroup && wj.browser.versions.ios) {
      var $body = $('body');
      document.title = title;
      // hack在微信等webview中无法修改document.title的情况
      var $iframe = $('<iframe style="display:none;opacity: 0;" src=""></iframe>');
      $iframe.on('load', function () {
        setTimeout(function () {
          $iframe.off('load').remove();
        }, 0);
      }).appendTo($body);
    } else {
      document.title = title;
    }
  },
  openUrl: function (url) {
    let params = {}
    if (myTemp.refereeopenid) {
      params.refereeopenid = myTemp.refereeopenid;
    }
    if (myTemp.rscuid || myTemp.agentcuid) {
      params.rscuid = myTemp.rscuid || myTemp.agentcuid;
    }
    location.href = this.addUrlParamFromObj(url, params);
  },
  getismp: function (fun) {
    if (location.host.indexOf("localhost") > -1 && location.href.indexOf("ismp=1") > -1) {
      fun(true);
    } else {
      if (!wx.miniProgram) return;
      wx.miniProgram.getEnv(function (res) {
        fun(res.miniprogram);
      });
    }
  },
  //内嵌在小程序中的跳转，需要在页面引入wxjssdk1.32+
  mp: {
    nav: function (url) {
      if (!wx.miniProgram) return;
      wx.miniProgram.navigateTo({ url: url });
    },
    navBack: function (url) {
      if (!wx.miniProgram) return;
      wx.miniProgram.navigateBack({ url: url });
    },
    switch: function (url) {
      if (!wx.miniProgram) return;
      wx.miniProgram.switchTab({ url: url });
    },
    rel: function (url) {
      if (!wx.miniProgram) return;
      wx.miniProgram.reLaunch({ url: url });
    },
    red: function (url) {
      if (!wx.miniProgram) return;
      wx.miniProgram.redirectTo({ url: url });
    }
  },
  /**
 * 从url上获取参数
 */
  getParamFromUrl(url) {
    if (url.indexOf("#wechat_redirect") > -1) {
      url = url.replace("#wechat_redirect", "");
    }
    let tmpObj = {};
    let tmpArr = url.split("?");
    if (tmpArr.length == 2) {
      let urlParam = tmpArr[1];
      let tmpArr1 = urlParam.split('&');
      tmpArr1 = tmpArr1.map(function (e) {
        tmpObj[e.split('=')[0]] = e.split('=')[1];
      })
    }
    return tmpObj;
  },
  getUrlRemoveParams(url) {
    url = url || location.href;
    if (url.indexOf("?") != -1) {
      url = url.split("?")[0];
      return url;
    }
    return url;
  },
  objToUrlParam(obj) {
    let urlParam = '';
    Object.keys(obj).forEach(function (e) {
      if (obj[e]) {
        urlParam += `${e}=${obj[e]}&`
      }
    })
    if (urlParam.length > 0) {
      urlParam = urlParam.substring(0, urlParam.length - 1);
    }
    return urlParam;
  },
  addUrlParamFromObj(url, obj) {
    let newUrl = this.getUrlRemoveParams(url);
    let newUrlParam = this.getParamFromUrl(url);
    newUrlParam = {
      ...newUrlParam,
      ...obj
    };
    let newUrlParamStr = this.objToUrlParam(newUrlParam);
    if (newUrlParamStr) {
      return newUrl + '?' + newUrlParamStr;
    }
    return newUrl;
  },
  getGuid: function () {
    let guid = "";
    for (var i = 1; i <= 32; i++) {
      var n = Math.floor(Math.random() * 16.0).toString(16);
      guid += n;
      if ((i == 8) || (i == 12) || (i == 16) || (i == 20))
        guid += "";
    }
    return guid;
  },
  isObject: function (p) {
    return Object.prototype.toString.call(p) === "[object Object]"
  },
  clientLog: {
    info() {
      this.clientLogFun(1, arguments)
    },
    warn() {
      this.clientLogFun(2, arguments)
    },
    error() {
      this.clientLogFun(3, arguments)
    },
    clientLogFun() {
      if (cfg.subdomian != 'qmyx') {
        return;
      }
      let filterMsg = '';
      let content = '';
      if (arguments[1].length == 0) {

      } else if (arguments[1].length == 1) {
        if (Object.prototype.toString.call(arguments[1][0]) === "[object String]") {
          filterMsg = arguments[1][0];
        }
      } else if (arguments[1].length == 2) {
        if (Object.prototype.toString.call(arguments[1][0]) === "[object String]") {
          filterMsg = arguments[1][0];
        }
        content = arguments[1][1];
        if (Object.prototype.toString.call(content) === "[object Object]" || Object.prototype.toString.call(content) === "[object Array]") {
          content = JSON.stringify(content);
        } else if (Object.prototype.toString.call(content) === "[object Null]") {
          content = 'Null';
        } else if (Object.prototype.toString.call(content) === "[object Undefined]") {
          content = 'Undefined';
        } else if (Object.prototype.toString.call(content) === "[object String]" || Object.prototype.toString.call(content) === "[object Number]") {

        } else {
          content = '';
        }
      } else if (arguments[1].length > 2) {

        if (Object.prototype.toString.call(arguments[1][0]) === "[object String]") {
          filterMsg = arguments[1][0];
        }
        content = []
        for (let index = 1; index < arguments[1].length; index++) {
          let element = arguments[1][index];
          if (Object.prototype.toString.call(element) === "[object Object]" || Object.prototype.toString.call(element) === "[object Array]") {
            element = JSON.stringify(element);
          } else if (Object.prototype.toString.call(element) === "[object Null]") {
            element = 'Null';
          } else if (Object.prototype.toString.call(element) === "[object Undefined]") {
            element = 'Undefined';
          } else if (Object.prototype.toString.call(element) === "[object String]" || Object.prototype.toString.call(element) === "[object Number]") {

          } else {
            element = '';
          }
          content.push(element);
        }
        content = JSON.stringify(content);
      }

      $.ajax({
        type: "POST",
        url: "https://log.yqyuntech.com/clientLog",
        async: false,
        data: {
          "repositoryId": 4,
          "levelId": arguments[0],
          "showId": window.myTemp.guid || '',
          "userId": window.myTemp.openid || '',
          "filterMsg": filterMsg,
          "content": content,
          "clientTime": new Date().getTime()
        },
        success: function (data) {
        }
      });
    }
  },
  getStrBlen(str) {
    let len = 0;
    for (let i = 0; i < str.length; i++) {
      if (str.charCodeAt(i) > 127 || str.charCodeAt(i) == 94) {
        len += 2;
      } else {
        len++;
      }
    }
    return len;
  },
  addForbidSlide() {
    document.getElementsByTagName("body")[0].style.overflow = "hidden";
    document.getElementsByTagName("body")[0].style.maxHeight = "100vh";
  },
  removeForbidSlide() {
    document.getElementsByTagName("body")[0].style.overflow = "";
    document.getElementsByTagName("body")[0].style.maxHeight = "";
  },
  handlerQwkf(toId) {
    let params = {
      corpId: myTemp.qwkfInfo.corpid,
      kfId: myTemp.qwkfInfo.openKfid
    }
    if (toId) {
      params.userId = toId;
    }
    comreq.getServicerUrl(params).then(res => {
      if (res.data) {
        let url = wj.addUrlParamFromObj(res.data, {
          scene_param: encodeURIComponent(JSON.stringify({
            tempid: myTemp.guid,
            openid: myTemp.openid || ''
          }))
        });
        myTemp.consultingLink = url;
      }
    })
  },
  loadJS(url, success) {
    let domScript = document.createElement('script');
    domScript.src = url;
    success = success || function () { };
    domScript.onload = domScript.onreadystatechange = function () {
      if (!this.readyState || 'loaded' === this.readyState || 'complete' === this.readyState) {
        success();
        this.onload = this.onreadystatechange = null;
        this.parentNode.removeChild(this);
      }
    }
    document.getElementsByTagName('head')[0].appendChild(domScript);
  }
};

/**
 * loading
 */
window.myTemp = {
  audio: null, //音乐对象
  arrSrc: [], //图片列表
  arrSrcMyServer: [], //本地WebServer上的图片进行预加载
  guid: '',
  openid: "",
  passport: "",
  appid: "",
  refereeopenid: "",
  bottomBtnCount: 0,
  isRecordIng: 0,
  img_text: {
    audioList: []
  },
  receiveMsgOpenId: "", //接收消息人openid
  sendImgBaseData: "",
  imgFaceCut: null,
  countPv: 0,//阅读量
  likes: 0,//点赞量
  islike: 0,//自己点赞次数
  consultingLink: "",//咨询链接
  isAlreadyAfterActIpGetConsultingLink: false,//是否在act=ip之后请求了获取聊天对象
  isGetUpUserMobile: false,//是否请求获取过了上级手机号
  upUserMobile: "",//上级手机号
  share_api: "",
  psn: "",
  windowWidth: '',
  windowHeight: '',
  cookieKeys: {
    beforeAuthUrl: 'beforeAuthUrl_t1'
  },
  saleCardUser: {
    openid: '',
    info: {}
  },
  appMark: "crm",
  photoRewardConfig: {},//晒照配置
  qwQrCodeUrl: '',
  userIntegralInfo: null,//用户完整信息
  isOpenEncourage: 0,//是否打开无门槛
  cardUserExtInfo: null,//名片用户外部信息
  isShowBtnQwkf: false,//是否展示企微客服
  qwkfInfo: null,//企微客服信息
  gcj02: null,//坐标
  issubscribe: 0,//是否关注
  isBtnEncourageGoInvitePage: false,
  query: {},//页面参数
  isOpenSelfAction: 0,//是否开启内容自行动
  suspendSelfTimer: false,//暂停内容自行动计时器
  stopSelfTimer: false,//停止内容自行动计时器
  ipv6: '',
};

var tmpImgTimeImgId = 0;//当前图片id
var tmpImgTimeObj = {};
window.myPageData = {};
myPageData.PageId = wj.qs("id");
// if (wj.qs("refereeopenid")) {
//   wj.cookie.set("refereeopenid", wj.qs("refereeopenid"), 60 * 10);
// } else {
//   if (location.href.indexOf("passport") > -1 && wj.qs("openid") > -1 && wj.qs("signature") > -1) {

//   } else {
//     wj.cookie.delete("refereeopenid");
//   }
// }
// if (wj.cookie.get("refereeopenid")) {
//   myTemp.refereeopenid = wj.cookie.get("refereeopenid");
// }
// if (wj.qs("rscuid")) {
//   wj.cookie.set("rscuid", wj.qs("rscuid"), 60 * 10);
// } else {
//   if (location.href.indexOf("passport") > -1 && wj.qs("openid") > -1 && wj.qs("signature") > -1) {

//   } else {
//     wj.cookie.delete("rscuid");
//   }
// }
// if (wj.cookie.get("rscuid")) {
//   myTemp.rscuid = wj.cookie.get("rscuid");
// }
// if (wj.qs("psn")) {
//   wj.cookie.set("psn" + myPageData.PageId, wj.qs("psn"), 60 * 10);
// }
// if (wj.cookie.get("psn" + myPageData.PageId)) {
//   myTemp.psn = wj.cookie.get("psn" + myPageData.PageId);
// }

// if (wj.qs("processinstanceid")) {
//   wj.cookie.set("processinstanceid" + myPageData.PageId, wj.qs("processinstanceid"), 60 * 10);
// }
// if (wj.cookie.get("processinstanceid" + myPageData.PageId)) {
//   myTemp.processinstanceid = wj.cookie.get("processinstanceid" + myPageData.PageId);
// }
// if (wj.qs("fopenid")) {
//   wj.cookie.set("fopenid" + myPageData.PageId, wj.qs("fopenid"), 60 * 10);
// }
// if (wj.cookie.get("fopenid" + myPageData.PageId)) {
//   myTemp.fopenid = wj.cookie.get("fopenid" + myPageData.PageId);
// }
// var xcxuid = wj.qs("xcxuid"), xcxappid = wj.qs("xcxappid"), xcxprojectid = wj.qs("xcxprojectid"), xcxgzhappid = wj.qs("xcxgzhappid");
// if (xcxuid && xcxappid && xcxprojectid && xcxgzhappid) {
//   wj.cookie.set("xcxuid", xcxuid, 60 * 5);
//   wj.cookie.set("xcxappid", xcxappid, 60 * 5);
//   wj.cookie.set("xcxprojectid", xcxprojectid, 60 * 5);
//   wj.cookie.set("xcxgzhappid", xcxgzhappid, 60 * 5);
// } else {
//   xcxuid = wj.cookie.get("xcxuid"), xcxappid = wj.cookie.get("xcxappid"), xcxprojectid = wj.cookie.get("xcxprojectid"), xcxgzhappid = wj.cookie.get("xcxgzhappid");
// }
// var purephonenumber = wj.qs("purephonenumber");
// if (purephonenumber) {
//   wj.cookie.set("purephonenumber", purephonenumber, 60 * 5);
// } else {
//   purephonenumber = wj.cookie.get("purephonenumber");
// }

// var qsEntry = wj.qs("entry");
// if (qsEntry) {
//   wj.cookie.set("entry" + myPageData.PageId, qsEntry, 60 * 10);
// } else {
//   qsEntry = wj.cookie.get("entry" + myPageData.PageId);
// }
// var qsT9id = wj.qs("t9id");
// if (qsT9id) {
//   wj.cookie.set("t9id" + myPageData.PageId, qsT9id, 60 * 10);
// } else {
//   qsT9id = wj.cookie.get("t9id" + myPageData.PageId);
// }
// var qsT9psn = wj.qs("t9psn");
// if (qsT9psn) {
//   wj.cookie.set("t9psn" + myPageData.PageId, qsT9psn, 60 * 10);
// } else {
//   qsT9psn = wj.cookie.get("t9psn" + myPageData.PageId);
// }

// var qsHomeUrl = wj.qs("homeurl");
// if (qsHomeUrl) {
//   wj.cookie.set("homeurl" + myPageData.PageId, qsHomeUrl, 60 * 10);
// } else {
//   qsHomeUrl = wj.cookie.get("homeurl" + myPageData.PageId);
// }

(function () {
  let urlParam = wj.getParamFromUrl(location.href);
  if (urlParam.guid) {
    myTemp.guid = urlParam.guid
  } else {
    myTemp.guid = wj.getGuid()
  }
  myTemp.query = urlParam;
  myTemp.refereeopenid = urlParam.refereeopenid;
  myTemp.rscuid = urlParam.rscuid;
  myTemp.agentcuid = urlParam.agentcuid;
  myTemp.psn = urlParam.psn;
  myTemp.processinstanceid = urlParam.processinstanceid;
  myTemp.fopenid = urlParam.fopenid;
  myTemp.xcxuid = urlParam.xcxuid;
  myTemp.xcxappid = urlParam.xcxappid;
  myTemp.xcxprojectid = urlParam.xcxprojectid;
  myTemp.xcxgzhappid = urlParam.xcxgzhappid;
  myTemp.purephonenumber = urlParam.purephonenumber;
  myTemp.entry = urlParam.entry;
  myTemp.t9id = urlParam.t9id;
  myTemp.t9psn = urlParam.t9psn;
  myTemp.homeurl = urlParam.homeurl;

  myTemp.corpId = urlParam.corpId;
  myTemp.qwUserId = urlParam.qwUserId;
  myTemp.batchId = urlParam.batchId;

  if (myTemp.corpId && myTemp.qwUserId && myTemp.batchId) {
    myTemp.isWxworkGroupMsg = true;
  }

})();

function firstAuth() {
  var j = wj.qs("j");
  if (j) {
    var data = decodeURIComponent(j);
    data = JSON.parse(data);
    myTemp.appid = data.appid;
    myTemp.openid = data.openid;
    myTemp.passport = data.passport;
    var authObj = {
      appid: data.appid,
      openid: data.openid,
      passport: data.passport
    }
    // wj.cookie.set("openid", authObj.openid, 1 * 60 * 60 * 24, location.host);
    // wj.cookie.set("passport", authObj.passport, 1 * 60 * 60 * 24, location.host);
    wj.cookie.set("pack1_20171129", JSON.stringify(authObj), 1 * 60 * 60 * 24);
    if (authObj && authObj.openid) {
      wj.cookie.set("openid", authObj.openid, 1 * 60 * 60 * 24 * 365);
    }
    if (authObj && authObj.passport) {
      wj.cookie.set("passport", authObj.passport, 1 * 60 * 60 * 24 * 365);
    }
    wj.cookie.set("pack1_20171129_first", JSON.stringify(authObj), 1 * 60 * 60 * 24);
    secondAuthGetUrl();
  } else {
    //静默授权
    $.ajax({
      type: "GET",
      url: api.wx,
      async: false,
      data: {
        j: JSON.stringify({
          "url": location.href,
          "action": "getConfig",
          "requestParam": {}
        }),
        t: 6
      },
      success: function (data) {
        if (data && data.obj) {
          if (data.obj.share_api) {
            wj.cookie.set("share_api", data.obj.share_api, 60 * 10);
          }
          let authCallBackUrl = location.href.replace("#wechat_redirect", "");
          let urlParam = wj.getParamFromUrl(authCallBackUrl);
          delete urlParam.xcxcountry;
          delete urlParam.xcxprovince;
          delete urlParam.xcxcity;
          if (myTemp.guid) {
            urlParam.guid = myTemp.guid
          }
          authCallBackUrl = wj.addUrlParamFromObj(wj.getUrlRemoveParams(authCallBackUrl), urlParam);
          let authUrl = `${location.protocol}//${location.host}/qc-webapp/wxapi.do?appid=${data.obj.appid}&scope=snsapi_base&wxauthcburl=${encodeURIComponent(authCallBackUrl)}`;
          location.href = authUrl;
          return false;
        }

      }
    });
  }

}

function secondAuthGetUrl() {
  var dataObj = {
    "id": myPageData.PageId
  }
  if (myTemp.psn) {
    dataObj.psn = myTemp.psn;
  }
  if (myTemp.rscuid) {
    dataObj.rscuid = myTemp.rscuid;
  } else {
    dataObj.rscuid = myTemp.openid;
  }
  var haveuserinfo = 0;
  $.ajax({
    type: "GET",
    async: false,
    url: api.wx,
    data: {
      j: JSON.stringify({
        "action": "/hb/HbH5Action/getPageInfo",
        "requestParam": {
          obj: dataObj
        },
        "openid": myTemp.openid,
        "passport": myTemp.passport,
        "url": location.href
      })
    },
    success: function (data) {
      if (data) {
        haveuserinfo = data.haveuserinfo;
        myTemp.issubscribe = data.issubscribe;
      }
      if (data && data.obj && data.obj.PageData) {
        myPageData = JSON.parse(decodeURIComponent(data.obj.PageData.replace(/[+]/g, "%20")));
        wj.changeTitle(myPageData.BrowserTabTitle);
        if (data.obj.gzh_qrcode) {
          myPageData.gzh_qrcode = data.obj.gzh_qrcode;
        }
        if (data.obj.gzh_headimg) {
          myPageData.gzh_headimg = data.obj.gzh_headimg;
        }
        myPageData.Other = {};
        Object.keys(data.obj).forEach(function (e) {
          if (e != "PageData") {
            myPageData.Other[e] = data.obj[e];
          }
        })
        myTemp.appid = myPageData.Other.gzh_appid;
        console.log("getPageInfo", JSON.parse(JSON.stringify(myPageData)));
      } else {
        alert("文章已删除！")
      }
    }
  });
  if (haveuserinfo) {
    var authObj = JSON.parse(wj.cookie.get("pack1_20171129_first"));
    wj.cookie.set("pack1_20171129_second", JSON.stringify(authObj), 1 * 60 * 60 * 24);
    let beforeAuthUrl = wj.cookie.get(myTemp.cookieKeys.beforeAuthUrl)
    if (beforeAuthUrl) {
      wj.cookie.delete(myTemp.cookieKeys.beforeAuthUrl);
      location.href = decodeURIComponent(beforeAuthUrl);
    }
  } else {
    //有二次授权的话进行二次授权
    if (myPageData.Isrushiauth && myPageData.Isrushiauth == 1) {
      //如是授权
      var appid = "wxf1efeb9b9d6f6f06";
      var host = "rushi.rushinews.com";
      var scope = "snsapi_userinfo";
      var arrUrl = location.href.split("/");
      var strPage = arrUrl[arrUrl.length - 1];
      var authUrl = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" + appid + "&redirect_uri=http://" + host + "/qc-webapp/oauthcallback.do&response_type=code&scope=" + scope + "&state=http://" + location.host + "/h5/" + strPage + "#wechat_redirect";
      location.href = authUrl;
    }
    else if (myPageData.Isrushiauth && myPageData.Isrushiauth == 2) {
      //本公众号网页授权
      $.ajax({
        type: "GET",
        url: api.wx,
        async: false,
        data: {
          j: JSON.stringify({
            "url": location.href,
            "action": "getConfig",
            "requestParam": {}
          }),
          t: 6
        },
        success: function (data) {
          if (data && data.obj) {
            if (data.obj.share_api) {
              wj.cookie.set("share_api", data.obj.share_api, 60 * 10);
            }
            let authCallBackUrl = location.href.replace("#wechat_redirect", "");
            let urlParam = wj.getParamFromUrl(authCallBackUrl);
            delete urlParam.xcxcountry;
            delete urlParam.xcxprovince;
            delete urlParam.xcxcity;
            if (myTemp.guid) {
              urlParam.guid = myTemp.guid
            }
            authCallBackUrl = wj.addUrlParamFromObj(wj.getUrlRemoveParams(authCallBackUrl), urlParam);
            let authUrl = `${location.protocol}//${location.host}/qc-webapp/wxapi.do?appid=${data.obj.appid}&scope=snsapi_userinfo&wxauthcburl=${encodeURIComponent(authCallBackUrl)}`;
            location.href = authUrl;
            return false;
          }
        }
      });
    }
  }
}

function secondAuth() {
  var j = wj.qs("j");
  if (j) {
    //回调
    var data = decodeURIComponent(j);
    data = JSON.parse(data);
    myTemp.appid = data.appid;
    myTemp.openid = data.openid;
    myTemp.passport = data.passport;
    var authObj = {
      appid: data.appid,
      openid: data.openid,
      passport: data.passport
    }
    wj.cookie.set("pack1_20171129", JSON.stringify(authObj), 1 * 60 * 60 * 24);
    wj.cookie.set("pack1_20171129_second", JSON.stringify(authObj), 1 * 60 * 60 * 24);
    let beforeAuthUrl = wj.cookie.get(myTemp.cookieKeys.beforeAuthUrl)
    if (beforeAuthUrl) {
      wj.cookie.delete(myTemp.cookieKeys.beforeAuthUrl);
      location.href = decodeURIComponent(beforeAuthUrl);
    }
  }
}
// 如果是在企微打开就替换成企微的路径
if (wj.browser.versions.wxwork && !cfg.isLoc) {
  location.replace(location.href.replace("/h5/", "/qwh5/"));
} else {
  if (wj.browser.versions.wxGroup) {
    if (location.href.indexOf("id=5253") > -1) {
      // 不走授权
    } else {
      let urlParams = wj.getParamFromUrl(location.href);
      // 兼容企微转发的链接调整api路径
      if (wj.browser.versions.wx && urlParams.gzhSubDomain) {
        window.cfg.apihost = `${urlParams.gzhSubDomain}.ttrushi.com`;
        window.api = {
          h5: location.protocol + "//" + cfg.apihost + "/qc-webapp/h5count.do?",
          wx: location.protocol + "//" + cfg.apihost + "/qc-webapp/wxapi.do",
          wxQcwebapp: location.protocol + "//" + cfg.apihost + "/qc-webapp"
        }
      }
      // 如果是企微域名的链接，且在微信环境下
      if (wj.browser.versions.wx && urlParams.gzhDomain && (location.host == 'qywx.ruthus.com' || location.host == 'qyweb.gbtse.com' || location.host == 'cloudwebtest.circlemartech.com' || location.host == 'cloudweb.circlemartech.com')) {
        if (urlParams.openid) {
          delete urlParams.openid;
        }
        if (urlParams.passport) {
          delete urlParams.passport;
        }
        location.href = wj.addUrlParamFromObj(wj.getUrlRemoveParams(location.href).replace(location.host, urlParams.gzhDomain), urlParams);
      } else {
        if (urlParams.openid && urlParams.passport) {
          myTemp.openid = urlParams.openid;
          myTemp.passport = urlParams.passport;
        } else {
          var isFirstAuth = wj.cookie.get("pack1_20171129_first");
          var isSecondAuth = wj.cookie.get("pack1_20171129_second");
          if (isFirstAuth) {
            var authObj = JSON.parse(wj.cookie.get("pack1_20171129_first"));
            myTemp.appid = authObj.appid;
            myTemp.openid = authObj.openid;
            myTemp.passport = authObj.passport;
            if (!isSecondAuth) {
              secondAuth();
              // 两步授权取消第二步授权，下次继续授权。
              isSecondAuth = wj.cookie.get("pack1_20171129_second");
              if (!isSecondAuth) {
                secondAuthGetUrl();
              }
            }
          } else {
            // 存授权之前的链接
            let urlParam = wj.getParamFromUrl(location.href);
            if (!urlParam.j) {
              let url = location.href;
              if (myTemp.guid) {
                url = wj.addUrlParamFromObj(location.href, {
                  guid: myTemp.guid
                })
              }
              wj.cookie.set(myTemp.cookieKeys.beforeAuthUrl, encodeURIComponent(url));
            }

            firstAuth();
          }
        }

      }
    }
  } else {
    if (cfg.isLoc) {
      var fake = wj.qs("fake");
      var tmpFake = null;
      switch (fake) {
        case "xszb_hope":
          tmpFake = {
            openid: 'oBbcUwpoEvfC-k3M8xszjYv2RMzA', passport: 'de5de29f32538e65426298bf159c0a52',
          }
          break;
        case "zhpr_hope":
          tmpFake = {
            openid: 'o6rXU5ug9gyiFAhg7q72qGXyBf2I', passport: '7e8fc6476ceeb73a6c1818fe0f68ee43',
          }
          break;
        case "gjzsyyyz_hope":
          tmpFake = {
            openid: 'oKJ5l691ciNpdwJKjNSRbCxkXrXI', passport: '1b29b8ad3a2ea854c375ec9c5c8323c2',
          }
          break;
        case "yunluh_hope":
          tmpFake = {
            openid: 'oWcKF5gMtStjCAy2f-b05VJQQBhs', passport: '8bbfa1848f06cd0b1c58aa1a57393f64',
          }
          break;
        case "qmyx_wmw2":
          tmpFake = {
            openid: 'oj3y9wL525i2ULnLhJBXONhdqjcY', passport: 'bf8a1125ea17bac81a1ae76d74d6a16f',
          }
          break;
        case "qmyx_backup":
          tmpFake = {
            "openid": "oj3y9wHZpLgtwJEhe878vunKBGGo", "passport": "aecd14f7d1f41b4b495fa862011f8c54",
          }
          break;
        case "zqwkh_kehu":
          tmpFake = {
            openid: 'o-EzxjsCbrQI3FKC8XC9YD5CaZVo', passport: '94d9f2313fbc4a0eb6277786530842bd',
          }
          break;
        case "qmyx_liuchen":
          tmpFake = {
            openid: 'oj3y9wBoiMJFxGTN53ibM1YZV11k', passport: '1be171cdfbb987e9b543e474f8ffac68',
          }
          break;
        case "ygcgz_hope":
          tmpFake = {
            openid: 'oi-dDxDU1Ak6PlwoPUuL7gSMK1b4', passport: '9b6d69a2bb1b8eaba44a5ed716caf229',
          }
          break;
        case "jqxf_hope":
          tmpFake = {
            openid: 'oNJ7h5vp92wye5dKWt6_ghvfPFBY', passport: '6934b3203ea267d18a423ed4c5346df3',
          }
          break;
        case "ajjt_hope":
          tmpFake = {
            openid: 'oI2pf6AwK8o1y8sr3mD6Z37FI_lY',
            passport: 'd4ad1240e29555b07a3d47745311eac5',
          }
          break;
        case "rushi_hope":
          tmpFake = {
            openid: 'ooSW7wCba7oABRNDGptiL95zK6Ho',
            passport: 'eceb50439b45126f2782d627809c1095',
          }
          break;
        case "zzry_hope":
          tmpFake = {
            openid: 'oUdwBxITUi8gv8Y8ssKQ43adnVR8', passport: '2894a0be848e2686c4245a7391d25d3b'
          }
          break;
        case "tyry_hope":
          tmpFake = {
            openid: 'oLFKmjn8uDnOtW3RZPyi4JQY_NtY', passport: '599714bcd9838f7a1de2e5d4d5fdb25c'
          }
          break;
        case "zhbljq_hope":
          tmpFake = {
            openid: 'of-ews8OwsUW3OYCOTMJg6EedLcU', passport: 'aa4e7f6bf2b20a29eb0228ae9f0cd7fc'
          }
          break;
        case "sdeer_hope":
          tmpFake = {
            openid: 'odpLNtypUl1ywR05wQbTKh-GaUpk', passport: '1df9e09e8dd750c164297eb15b0bfc25'
          }
          break;
        // http://localhost:2006/t1.html?fake=qmyx_hope&id=169852&psn=25d4f30a8ef94db18d1a7bfe104a07a7
        case "qmyx_hope":
          tmpFake = {
            openid: 'oj3y9wGThdLqhn0bZWOj7DeO2Tww', passport: 'b4de197ab7b03e9d014116821e90d54f'
          }
          myTemp.appid = 'wx01f0b018d4951434';
          break;
        case "qmyx_luchao":
          tmpFake = {
            openid: 'oj3y9wJGqRFqo0ToSzw5y4rzoVQ4', passport: 'e22f991d907f4e087ec746eaf0859912'
          }
          myTemp.appid = 'wx01f0b018d4951434';
          break;
        case "qmyx_may":
          tmpFake = {
            openid: 'oj3y9wLPfkK5dkr9rK9i3GyGIXwE', passport: 'b212d1bb3eb7e5ab971f0a8dcb327829'
          }
          myTemp.appid = 'wx01f0b018d4951434';
          break;
        case "qmyx_lyx":
          tmpFake = {
            openid: 'oj3y9wNKtjyOHOTUL-O8EXSFhjL0', passport: '1bb1e9ef7cea60bf6f6ffa1bfc3d0f8c',
          }
          myTemp.appid = 'wx01f0b018d4951434';
          break;
        case "yqjisu_wuping":
          tmpFake = {
            openid: 'oPg9r1atkMsQUZ7sxsU4YC3oZsbE', passport: '49f76f931116de2334d637b3f0230957',
          }
          break;
        case "yqjisu_lyx":
          tmpFake = {
            openid: 'oPg9r1aimvXOUotA6zPQYFZAmVkw', passport: '612d0783b9bdb34eab1c7082cc8541a4',
          }
          break;
        case "jmzzls_hope":
          tmpFake = {
            openid: 'o7nE1wWtRWnVgQ3NeCJE94t5w4iY', passport: '0a48ffc175a1d6e5d931c3442be089a3',
          }
          break;
        case "qmyx_jiegeng":
          tmpFake = {
            openid: 'oj3y9wCIDo_Gajnck5QVxBZOVyUA', passport: '26d4b82ba90d3d847a9a0ddc151d89bb',
          }
          myTemp.appid = 'wx01f0b018d4951434';
          break;
        case "yqjisu_hope":
          tmpFake = {
            openid: 'oPg9r1WEa_1ikSKWlMeJonVwQHdQ', passport: '70021c7e84e0da8787bab5eb3669590d',
          }
          break;
        case "cqwkh_hope":
          tmpFake = {
            openid: 'o0_1g6pRM2LyQSPVylwKW-siGdPc', passport: '898b3150bfec51bdac6ba954359958b8',
          }
          break;
        case "cqwkh_xmw":
          tmpFake = {
            openid: 'o0_1g6suNOnk74Vanyz9s9jF9zPo', passport: '1b457df1e60d11e2f0228b3f6f876f13',
          }
          break;
        case "yqjisu_kq":
          tmpFake = {
            openid: 'oPg9r1ZUUU7HsOTsU22nYUCeQCYY', passport: '83607d8ea9e915c7277858283edfbe05',
          }
          break;
        default:
          tmpFake = {
            openid: 'oj3y9wGThdLqhn0bZWOj7DeO2Tww', passport: 'b4de197ab7b03e9d014116821e90d54f'
          }
          myTemp.appid = 'wx01f0b018d4951434';
          break;
      }
      if (tmpFake) {
        myTemp.openid = tmpFake.openid;
        myTemp.passport = tmpFake.passport;
      }
    }
  }
}
(function () {
  if (wj.browser.versions.wxGroup) {
    // 授权一致性校验
    var isFirstAuth = wj.cookie.get("pack1_20171129_first");
    var isSecondAuth = wj.cookie.get("pack1_20171129_second");
    var authObj = wj.cookie.get("pack1_20171129");
    if ((isFirstAuth && isSecondAuth && authObj) || (isFirstAuth && authObj)) {
      isFirstAuth = JSON.parse(isFirstAuth);
      authObj = JSON.parse(authObj);
      if (isSecondAuth) {
        isSecondAuth = JSON.parse(isSecondAuth);
      } else {
        isSecondAuth = { openid: "" }
      }

      if ((isFirstAuth.openid == isSecondAuth.openid && isFirstAuth.openid == authObj.openid) || isFirstAuth.openid == authObj.openid) {

      } else {
        wj.cookie.delete("pack1_20171129_first");
        wj.cookie.delete("pack1_20171129_second");
        wj.cookie.delete("pack1_20171129");
        // var strUrl = location.href.split('?')[0];
        // strUrl += "?id=" + myPageData.PageId;
        // strUrl += "&psn=" + myTemp.psn;
        // if (wj.cookie.get("refereeopenid")) {
        //   myTemp.refereeopenid = wj.cookie.get("refereeopenid");
        //   strUrl += "&refereeopenid=" + myTemp.refereeopenid;
        // }
        // location.href = strUrl;
        location.reload();
      }
    }
  }
})();

(function () {
  var dataObj = {
    "id": myPageData.PageId
  }
  if (myTemp.psn) {
    dataObj.psn = myTemp.psn;
  }
  if (myTemp.rscuid) {
    dataObj.rscuid = myTemp.rscuid;
  } else {
    dataObj.rscuid = myTemp.openid;
  }
  $.ajax({
    type: "GET",
    async: false,
    url: api.wx,
    data: {
      j: JSON.stringify({
        "action": "/hb/HbH5Action/getPageInfo",
        "requestParam": {
          obj: dataObj
        },
        "openid": myTemp.openid,
        "passport": myTemp.passport,
        "url": location.href
      })
    },
    success: function (data) {
      if (data && data.obj && data.obj.PageData) {
        myTemp.issubscribe = data.issubscribe;
        myPageData = JSON.parse(decodeURIComponent(data.obj.PageData.replace(/[+]/g, "%20")));
        console.log("11111111111", JSON.parse(JSON.stringify(myPageData)));
        wj.changeTitle(myPageData.BrowserTabTitle);
        if (data.obj.gzh_qrcode) {
          myPageData.gzh_qrcode = data.obj.gzh_qrcode;
        }
        if (data.obj.gzh_headimg) {
          myPageData.gzh_headimg = data.obj.gzh_headimg;
        }
        myPageData.Other = {};
        Object.keys(data.obj).forEach(function (e) {
          if (e != "PageData") {
            myPageData.Other[e] = data.obj[e];
          }
        })
        myTemp.appid = myPageData.Other.gzh_appid;
      } else {
        // alert("H5内容获取失败！")
      }
    }
  });
})();

if (wj.cookie.get("share_api")) {
  myTemp.share_api = wj.cookie.get("share_api");
}

// if (wj.cookie.get("refereeopenid")) {
//   myTemp.refereeopenid = wj.cookie.get("refereeopenid");
// }

// if (wj.cookie.get("rscuid")) {
//   myTemp.rscuid = wj.cookie.get("rscuid");
// }

if (wj.browser.versions.wxGroup) {
  initWXJSSDK();
}
if (myPageData.Imgs && myPageData.Imgs.length == 1) {
  $(".arrow").addClass("hide");
}
if (myPageData.Imgs) {
  myPageData.Imgs.forEach(function (e, i) {
    myTemp.arrSrc.push(e.filepath);
  })
}
if (myPageData.CsPic)
  myTemp.arrSrc.push(myPageData.CsPic);
if (myPageData.WxQrcode)
  myTemp.arrSrc.push(myPageData.WxQrcode);
myTemp.arrSrc.forEach(function (e, i) {
  if (e.indexOf("rs.static.rushinews.com") > -1 || e.indexOf(location.host) > -1 || e.indexOf("../") > -1) {
    myTemp.arrSrcMyServer.push(e);
  }
})
if (myPageData.Redirectto == 1) {
  // 问卷还让页面停留在loading
} else {
  if (myTemp.arrSrcMyServer.length > 0) {
    wj.loadImgs(myTemp.arrSrcMyServer, function () {
      console.count("加载图片");
    }, function () {
      $(".index_scrim").css("display", "none");
      bindMusic();
    })
  } else if (myPageData.Imagetext && myPageData.Imagetext != "") {
    //图文类型
    $(".index_scrim").css("display", "none");
    bindMusic();
  } else {
    $(".index_scrim").css("display", "none");
    bindMusic();
  }
}


function bindMusic() {
  //绑定音乐
  if (myPageData.Music) {
    if (myPageData.Music.indexOf(".mp3") > -1 || myPageData.Music.indexOf(".MP3") > -1) {
      myTemp.audio = document.getElementById("music_audio");
      if (wj.browser.versions.ios) {
        myTemp.audio.src = myPageData.Music;
        setTimeout(function () {
          myTemp.audio.play();
        }, 150)
        document.addEventListener("WeixinJSBridgeReady", function () {
          myTemp.audio.play();
        }, false);
        $(".music_img").addClass("music_img_play");
      } else {
        // wj.loadAudio(myPageData.Music, function () {
        //     myTemp.audio.src = myPageData.Music;
        //     myTemp.audio.play();
        //     $(".music_img").addClass("music_img_play");
        // });
        // myTemp.audio.src = myPageData.Music;

        myTemp.audio.src = myPageData.Music;
        var isPlaying = myTemp.audio.currentTime > 0 && !myTemp.audio.paused && !myTemp.audio.ended && myTemp.audio.readyState > 2;
        if (!isPlaying) {
          setTimeout(function () {
            myTemp.audio.play().catch(function (e) {
              console.log("", e.message);
              console.log("", e.description);
            });
            $(".music_img").addClass("music_img_play");
          }, 150);
        } else {

        }
      }
      //点击音乐图标
      $(".music").on("click", function () {
        if (myTemp.audio.paused) {
          myTemp.audio.play();
          $(".music_img").addClass("music_img_play");
        } else {
          myTemp.audio.pause();
          $(".music_img").removeClass("music_img_play");
        }
      });
    } else {
      alert("仅支持mp3格式音乐！")
    }
  }
}


/**
 * layout
 */
function fixPagesHeight() {
  var windowHeight = $(window).innerHeight();
  myTemp.windowHeight = windowHeight;
  myTemp.windowWidth = $(window).innerWidth();
  //显示阅读量，ffxx数，顶部关注按钮
  if ((myPageData.Showpv && myPageData.Showpv == 1) || (myPageData.Showshares && myPageData.Showshares == 1) || (myPageData.Showsubcribepage && myPageData.Showsubcribepage == 1 && myPageData.Subcribepageurl)) {
    $(".page .music").css({
      top: "3.5rem"
    })
    var tmpHeight = windowHeight - $(".count").height();
    $('.swiper-slide,.swiper-container').css({
      height: tmpHeight
    });
    $('.swiper-slide img').css({
      height: tmpHeight
    });
    $('.xn-wrapper').css({
      top: "50px"
    })

    if ((myPageData.Showpv && myPageData.Showpv == 1 || myPageData.Showshares && myPageData.Showshares == 1)) {
      getCount();
    }
    if (myPageData.Showsubcribepage && myPageData.Showsubcribepage == 1 && myPageData.Subcribepageurl != "") {
      $(".count_subcribe").removeClass("hide")
      $(".count_subcribe").on("click", function () {
        AddCount(14);
        location.href = myPageData.Subcribepageurl;
      })
    }
    //请求接口获取数量
    // $(".count").removeClass("hide");

  } else {
    $('.swiper-slide,.swiper-container').css({
      height: windowHeight
    });
    $('.swiper-slide img').css({
      height: windowHeight
    });
  }

  // $(".page").css({
  //     height: windowHeight
  // });
}

fixPagesHeight();
window.onresize = function () {
  fixPagesHeight();
}
//根据配置显示按钮
if (location.host.indexOf("henduobao") > -1) {
  $(".bt_comm").addClass("hide");
  $(".bt_hdb").removeClass("hide");
}
if (location.host.indexOf("shnkyn.") > -1) {
  $(".btn_dy_a .txt").html("报名");
}
if (myPageData.PageId == "1993" || myPageData.PageId == "2210" || myPageData.PageId == "2206" || myPageData.PageId == "4695" || myPageData.PageId == "69128") {
  $(".btn_dy_a .txt").html("投票");
}
if (myPageData.PageId == "5783") {
  $(".btn_dy_a .txt").html("有奖问卷");
}

if (!myPageData.Music) {
  $(".music").css({
    "display": "none"
  });
}
if (myPageData.IsPhone) {
  $(".btn_th").css("display", "block");
  myTemp.bottomBtnCount++;
}
// 显示致电
if (myPageData.Tel || myPageData.Propcall) {
  $(".btn_zd").css("display", "block");
  myTemp.bottomBtnCount++;
}
if (myPageData.Chat) {
  if (wj.browser.versions.wxGroup || window.cfg.isLoc) {
    $(".btn_zx").css("display", "block");
    myTemp.bottomBtnCount++;
  }
}
if (myPageData.NavUrl) {
  $(".btn_dh").css("display", "block");
  myTemp.bottomBtnCount++;
}
if (myPageData.WxCode && myPageData.WxQrcode) {
  $(".btn_gw").css("display", "block");
  myTemp.bottomBtnCount++;
}
if ((myPageData.Survey || myPageData.Surveyext) && myTemp.bottomBtnCount < 5) {
  $(".btn_dy").css("display", "block");
  myTemp.bottomBtnCount++;
  new Promise(function (resolve, reject) {
    // getuserinfo
    $.ajax({
      type: "GET",
      async: true,
      url: api.wx,
      data: {
        j: JSON.stringify({
          "action": "/persid/PresidentAction/selectHbextend",
          "requestParam": {
            openid: myTemp.openid
          },
          "openid": myTemp.openid,
          "passport": myTemp.passport,
          "url": location.href
        })
      },
      success: function (data) {
        if (data && data.obj && data.obj.length > 0) {
          resolve(data.obj[0]);
        } else {
          resolve(false);
        }
      }
    });
  }).then(function (myUserInfo) {
    if (myPageData.Surveyext) {
      myPageData.Survey = myPageData.Surveyext;
    }
    myPageData.Survey = myPageData.Survey.replace("ddipctest", "wjpro");
    myPageData.Survey = wj.addUrlParamFromObj(myPageData.Survey, { host: location.host });
    if (myPageData.PageId) myPageData.Survey = wj.addUrlParamFromObj(myPageData.Survey, { pageid: myPageData.PageId });
    if (myTemp.appid) myPageData.Survey = wj.addUrlParamFromObj(myPageData.Survey, { appid: myTemp.appid });
    if (myTemp.openid) myPageData.Survey = wj.addUrlParamFromObj(myPageData.Survey, { openid: myTemp.openid });
    if (myTemp.refereeopenid) myPageData.Survey = wj.addUrlParamFromObj(myPageData.Survey, { refereeopenid: myTemp.refereeopenid });
    if (myUserInfo) {
      if (myUserInfo.name) myPageData.Survey = wj.addUrlParamFromObj(myPageData.Survey, { nickname: encodeURIComponent(myUserInfo.name) });
      if (myUserInfo.headimgurl) myPageData.Survey = wj.addUrlParamFromObj(myPageData.Survey, { headimage: encodeURIComponent(myUserInfo.headimgurl) });
    }
    if (myPageData.Surveyhideid && myPageData.Surveyhideanswer) {
      myPageData.Survey = wj.addUrlParamFromObj(myPageData.Survey, { Surveyhideid: myPageData.Surveyhideid });
      myPageData.Survey = wj.addUrlParamFromObj(myPageData.Survey, { Surveyhideanswer: encodeURIComponent(myPageData.Surveyhideanswer) });
    }
    myPageData.Survey = wj.addUrlParamFromObj(myPageData.Survey, { share_link: encodeURIComponent(location.href) });
    // 直达
    if (myPageData.Redirectto == 1 && myTemp.openid) {
      SendTime(function () {
        wj.openUrl(myPageData.Survey);
      })
    }
  })

}
if (myPageData.Mall && myTemp.bottomBtnCount < 5) {
  $(".btn_sc").css("display", "block");
  myTemp.bottomBtnCount++;
}
if (myPageData.LiveUrl && myTemp.bottomBtnCount < 5) {
  $(".btn_live").css("display", "block");
  myTemp.bottomBtnCount++;
}
if (myPageData.Record && myTemp.bottomBtnCount < 5) {
  $(".btn_record").css("display", "block");
  myTemp.bottomBtnCount++;
}
if (myPageData.Photo && parseInt(myPageData.Photo) == 1 && myTemp.bottomBtnCount < 5) {
  $(".btn_photo").css("display", "block");
  myTemp.bottomBtnCount++;
  comreq.getPhotoRewardConfig(myPageData.PageId).then((res) => {
    if (res.obj) {
      myTemp.photoRewardConfig = res.obj;
      console.log("myTemp.photoRewardConfig", myTemp.photoRewardConfig);
    }
  })
}
if (myPageData.PageId == 3136) {
  $(".btn_photo").css("display", "block");
  myTemp.bottomBtnCount++;
}
//街景
if (myPageData.Streeturl && myTemp.bottomBtnCount < 5) {
  $(".btn_street").css("display", "block");
  myTemp.bottomBtnCount++;
  $(".btn_street").on("click", function () {
    removeBottomAllActiveClass(this)
    AddCount(8);
    wj.openUrl(myPageData.Streeturl);
  })
}
//周边
if (myPageData.Nearbyurl && myTemp.bottomBtnCount < 5) {
  $(".btn_nearby").css("display", "block");
  myTemp.bottomBtnCount++;
  $(".btn_nearby").on("click", function () {
    removeBottomAllActiveClass(this)
    AddCount(9);
    wj.openUrl(myPageData.Nearbyurl);
  })
}
//抽奖
if (myPageData.Luckdrawurl && myTemp.bottomBtnCount < 5) {
  let luckdrawBtnName = '';
  if (myPageData.Luckdrawurl.indexOf('http') != 0) {
    let encodeUrls = JSON.parse(myPageData.Luckdrawurl)
    console.log(111, 'encodeUrls', encodeUrls)
    if (encodeUrls.position == 2) {
      // 悬浮按钮模式
      $(".btn_luckdraw2").removeClass("hide");
      luckdrawBtnName = "btn_luckdraw2";
      if (encodeUrls.name) {
        if (encodeUrls.name.length > 4) {
          encodeUrls.name = encodeUrls.name.substring(0, 4);
        }
        $(".btn_luckdraw2Name").html(encodeUrls.name)
      } else {
        $(".btn_luckdraw2Name").html('抽奖')
      }
    } else {
      if (encodeUrls.name) {
        $(".btn_luckdraw .txt").html(encodeUrls.name)
      }
      myTemp.bottomBtnCount++;
      $(".btn_luckdraw").css("display", "block");
      luckdrawBtnName = "btn_luckdraw";
    }
  } else {
    myTemp.bottomBtnCount++;
    $(".btn_luckdraw").css("display", "block");
    luckdrawBtnName = "btn_luckdraw";
  }
  $("." + luckdrawBtnName).on("click", function () {
    if (luckdrawBtnName == 'btn_luckdraw') {
      removeBottomAllActiveClass(this)
    }

    AddCount(10);
    if (myPageData.Luckdrawurl.indexOf('http') == 0) {
      wj.openUrl(myPageData.Luckdrawurl);
    } else {
      let encodeUrls = JSON.parse(myPageData.Luckdrawurl)
      if (encodeUrls.exturl) {
        if (myTemp.refereeopenid) {
          encodeUrls.exturl = wj.addUrlParamFromObj(encodeUrls.exturl, {
            refereeopenid: myTemp.refereeopenid
          })
        }
        wj.openUrl(encodeUrls.exturl)
      } else {
        if (myTemp.refereeopenid) {
          encodeUrls.url = wj.addUrlParamFromObj(encodeUrls.url, {
            refereeopenid: myTemp.refereeopenid
          })
        }
        wj.openUrl(encodeUrls.url)
      }
    }
  })
}
//评论
if (myPageData.Reviewurl && myTemp.bottomBtnCount < 5) {
  $(".btn_review").css("display", "block");
  myTemp.bottomBtnCount++;
  $(".btn_review").on("click", function () {
    removeBottomAllActiveClass(this)
    AddCount(11);
    wj.openUrl(myPageData.Reviewurl);
  })
}
//表单
if (((myPageData.Formurl || myPageData.Formexturl) && myTemp.bottomBtnCount < 5) && !wj.browser.versions.dy) {
  $(".btn_form").css("display", "block");
  myTemp.bottomBtnCount++;
  if (myPageData.Formname) {
    $(".btn_form .txt").html(myPageData.Formname)
  }
  $(".btn_form").on("click", function () {
    removeBottomAllActiveClass(this)
    AddCount(12);
    myPageData.PageId = parseInt(myPageData.PageId);
    if (((location.host.indexOf("localhost") > -1 && location.href.indexOf("sdeer_hope") > -1)
      || location.host.indexOf("sdeer.") > -1)
      && myPageData.PageId == 150951) {
      var url = "http://wx649423c805e5d00e.web.ruth6666.com/act/online/sdeer-puchase/sdeer-puchase.html#/index?channel=" + myPageData.PageId;
      if (myTemp.refereeopenid) {
        url += "&fopenid=" + myTemp.refereeopenid;
      }
      // console.log(url);
      location.replace(url);
    } else {
      if (myPageData.Formexturl) {
        if (myTemp.refereeopenid) {
          myPageData.Formexturl = wj.addUrlParamFromObj(myPageData.Formexturl, {
            refereeopenid: myTemp.refereeopenid
          })
        }
        wj.openUrl(myPageData.Formexturl);
      } else {
        if (myTemp.refereeopenid) {
          myPageData.Formurl = wj.addUrlParamFromObj(myPageData.Formurl, {
            refereeopenid: myTemp.refereeopenid
          })
        }
        wj.openUrl(myPageData.Formurl);
      }
    }
  })
}
// 更多表单
// 支持打开小程序 用这种格式 mp#gh_cf374d75e052#pages/rs/index/index.html?pid=65ace257c16e48e4b41c20c92ab81528
if ((myPageData.Funcscfg && myTemp.bottomBtnCount < 5) && !wj.browser.versions.dy) {
  myPageData.Funcscfg = JSON.parse(myPageData.Funcscfg);
  if (myPageData.Funcscfg && myPageData.Funcscfg.length > 0) {
    myPageData.Funcscfg.forEach((item, index) => {
      if (myTemp.bottomBtnCount < 5) {
        myTemp.bottomBtnCount++;
        $(".btn_form_more" + index).css("display", "block");
        if (item.exturl && item.exturl.indexOf("mp#") > -1) {
          $(".btn_form_more" + index + "_other").css("display", "none");
          var mpPath = item.exturl.replace("mp#" + item.exturl.split("#")[1] + "#", "");
          if (mpPath.substring(0, 1) != "/") {
            mpPath = "/" + mpPath;
          }

          let script = document.createElement("script");
          script.type = "text/wxtag-template";
          script.text = `<img src="http://assets.rurushishi.com/h5/img/v2/menu_form.png" style=" width: 25px;height: 25px;margin: 10px auto 0 auto;display: block;"/>
          <span style="color: #000000;font-size: 12px;margin-top: 4px;display: inline-block;">${item.label}</span>`;

          let html = `<wx-open-launch-weapp class="btn_xcx_more0_mp_launch_wx" username="${item.exturl.split("#")[1]}" path="${mpPath}">${script.outerHTML}</wx-open-launch-weapp>`;
          $(".btn_form_more" + index + "_mp_launch").html(html);
        } else {
          $(".btn_form_more" + index + "_mp_launch").css("display", "none");
          if (item.label) {
            $(".btn_form_more" + index + " .txt").html(item.label);
          }
          $(".btn_form_more" + index).on("click", function () {
            AddCount(12);
            myPageData.PageId = parseInt(myPageData.PageId);
            if (((location.host.indexOf("localhost") > -1 && location.href.indexOf("sdeer_hope") > -1)
              || location.host.indexOf("sdeer.") > -1)
              && myPageData.PageId == 150951) {
              var url = "http://wx649423c805e5d00e.web.ruth6666.com/act/online/sdeer-puchase/sdeer-puchase.html#/index?iscreate=2&channel=" + myPageData.PageId;
              if (myTemp.refereeopenid) {
                url += "&fopenid=" + myTemp.refereeopenid;
              }
              // console.log(url);
              location.replace(url);
            } else {
              if (item.exturl) {
                if (myTemp.refereeopenid) {
                  item.exturl = wj.addUrlParamFromObj(item.exturl, {
                    refereeopenid: myTemp.refereeopenid
                  })
                }
                wj.openUrl(item.exturl);
              } else {
                if (myTemp.refereeopenid) {
                  item.url = wj.addUrlParamFromObj(item.url, {
                    refereeopenid: myTemp.refereeopenid
                  })
                }
                wj.openUrl(item.url);
              }
            }
          })
        }
      }
    })
  }
}


//传播咨询
/**
 * 1、有rscuid聊天对象是rscuid
 * 2、以上步骤没有，则通过获取上级销售找到聊天对象
 * 3、以上步骤没有，则通过获取默认接待找到聊天对象
 * 4、以上步骤没有，则使用默认的PC端咨询回复
 */
// async function setSpreadChat(isAfterActIpGet) {
//   return new Promise(async (resolve, reject) => {
//     if (myTemp.consultingLink && !isAfterActIpGet) {
//       resolve(myTemp.consultingLink)
//     } else {
//       let toId = '';
//       if (myTemp.rscuid && myTemp.rscuid != myTemp.openid) {
//         toId = myTemp.rscuid;
//       } else {
//         let upSaleOpenid = await window.comreq.getUserUpFans();
//         if (upSaleOpenid) {
//           toId = upSaleOpenid;
//         } else {
//           let defaultSaleOpenid = await window.comreq.getReceptionByProject();
//           if (defaultSaleOpenid) {
//             toId = defaultSaleOpenid;
//           }
//         }
//       }
//       if (toId) {
//         // 放开 咨询跳转到新百宝箱聊天页面
//         myTemp.consultingLink = `${location.protocol}//${location.host}/marketies/desk/pages/fans/sale-fans-interaction?receiveropenid=${toId}&projectid=${myPageData.Pid}&pageid=${myPageData.PageId}`;
//         // myTemp.consultingLink = `${location.protocol}//${location.host}/yqim/chat?fid=${toId}&projectid=${myPageData.Pid}`;
//         // if (cfg.isLoc || cfg.isTest) {
//         // } else {
//         //   myTemp.consultingLink = `${location.protocol}//${location.host}/newcode/src/chat_room.html?openid=${myTemp.openid}&passport=${myTemp.passport}&referenceopenid=${myTemp.refereeopenid}&rscuid=${myTemp.rscuid}&receiveropenid=${toId}&nickname=&pageid=${myPageData.PageId}&projectid=${myPageData.Pid}`;
//         // }
//       } else {
//         myTemp.consultingLink = `${location.protocol}//${location.host}/marketies/rc/cus-service.html?mobile=${myPageData.Tel}&referenceopenid=${myTemp.refereeopenid}&pageid=${myPageData.PageId}`;
//       }
//       if (isAfterActIpGet) {
//         myTemp.isAlreadyAfterActIpGetConsultingLink = true;
//         setContentSelf();
//       }
//       resolve(myTemp.consultingLink)
//     }
//   })
// };

if (myPageData.Isconsult && parseInt(myPageData.Isconsult) == 1 && myTemp.bottomBtnCount < 5) {
  $(".btn_consult").css("display", "block");
  myTemp.bottomBtnCount++;
  $(".btn_consult").on("click", function () {
    removeBottomAllActiveClass(this)
    // 去除点击咨询按钮时的统计
    // AddCount(13);

    // setSpreadChat().then(url => {
    //   // 在线售楼中心
    //   if (myTemp.entry == "zxslzx" && myTemp.t9id && myTemp.t9psn) {
    //     url = wj.addUrlParamFromObj(wj.getUrlRemoveParams(url), {
    //       entry: 'zxslzx',
    //       t9id: myTemp.qsT9id,
    //       t9psn: myTemp.qsT9psn
    //     })
    //   }
    //   location.href = url;
    // })
    // 20201225采用新逻辑
    let url = myTemp.consultingLink;

    // 在线售楼中心
    if ((myTemp.entry == "zxslzx" || myTemp.entry == "showcenter") && myTemp.t9id && myTemp.t9psn) {
      url = wj.addUrlParamFromObj(url, {
        entry: myTemp.entry,
        t9id: myTemp.t9id,
        t9psn: myTemp.t9psn
      })
    }
    // 打开的不是企微客服链接的时候加带qwQrCodeUrl
    if (url.indexOf('work.weixin.qq.com') < 0) {
      if (myTemp.qwQrCodeUrl) {
        url = wj.addUrlParamFromObj(url, {
          qwQrCodeUrl: encodeURIComponent(myTemp.qwQrCodeUrl)
        })
      }
    }
    location.href = url;
  })
}

//关注
if (myPageData.Showsubcribebtn && parseInt(myPageData.Showsubcribebtn) == 1 && myTemp.bottomBtnCount < 5) {

  $(".btn_subcribe").css("display", "block");
  $(".btn_subcribe").on("click", function () {
    removeBottomAllActiveClass(this)
    AddCount(15);
    location.href = myPageData.Subcribepageurl;
  })
  myTemp.bottomBtnCount++;
}


(function () {
  function getTmpBtnEle(btnId, btnName, btnDefaultIcon = 'icon-form') {
    let tmpBtn = `<div class="item btn_form_more${btnId} reset-item">
    <div class="btn_form_more${btnId}_other">
      <div class="icon-item">
        <div class="item-bg">
          <i class="iconfont ${btnDefaultIcon}"></i>
        </div>
      </div>
      <div class="txt">${btnName}</div>
      </div>
    </div>`;
    $(".bt_comm").append(tmpBtn);
    $(`.btn_form_more${btnId}`).css({
      "display": "block"
    })
  }

  if (myPageData.Other && myPageData.Other.funcs && myPageData.Other.funcs.length > 0) {
    myPageData.Other.funcs.forEach(item => {
      if (myTemp.bottomBtnCount < 5) {
        let isAdd = false;
        if (item.isvalid == 1) {
          let funcData = item.funcData;
          if (funcData && Object.prototype.toString.call(funcData) === "[object String]") {
            funcData = JSON.parse(funcData);
          }
          console.log('funcData', funcData)
          if (item.funcType == "noreg_recommend_customer" && item.funcName && item.funcUrl) {
            let btnId = wj.getGuid();
            getTmpBtnEle(btnId, item.funcName)
            $(`.btn_form_more${btnId}`).on("click", function () {
              wj.openUrl(item.funcUrl);
            })
            isAdd = true;
          } else if (item.funcType == "houseconfig") {
            $(".btn_appointment").css("display", "block");
            if (funcData.name) {
              $(".btn_appointment .txt").html(funcData.name)
            }
            $(".btn_appointment").on("click", function () {
              let url = funcData.links;
              let addUrlParams = {
                pageid: myPageData.PageId,
                backurl: encodeURIComponent(location.href)
              }
              if (myTemp.refereeopenid) {
                addUrlParams.refereeopenid = myTemp.refereeopenid;
              }
              if (myTemp.rscuid) {
                addUrlParams.rscuid = myTemp.rscuid;
              }
              let urlDomain = url.split("/");
              url = url.replace(urlDomain[2], location.host);
              url = wj.addUrlParamFromObj(url, addUrlParams);
              wj.openUrl(url);
            })
            isAdd = true;
          } else if (item.funcType == "customerService" && funcData.serviceType == "qwService") {
            myTemp.isShowBtnQwkf = true;
            myTemp.qwkfInfo = funcData;
            $(".btn_qwkf").css("display", "block");
            $(".btn_qwkf").on("click", function () {
              wj.openUrl(myTemp.consultingLink);
            });
            isAdd = true;
          }

          if (isAdd) {
            myTemp.bottomBtnCount++;
          }
        }
      }
    })
  }

})();

if (myPageData.WxCode && myPageData.WxQrcode) {
  $(".contact").removeClass("hide");
}
if (myPageData.Tel) {
  $(".customservice").removeClass("hide");
}
if (myPageData.WxCode && myPageData.WxQrcode && myPageData.Tel) {
  $(".dividingline").removeClass("hide");
}

// 小程序按钮
if (myPageData.Funcscfg_wxxcx && myTemp.bottomBtnCount < 5) {
  myPageData.Funcscfg_wxxcx = JSON.parse(myPageData.Funcscfg_wxxcx);
  if (myPageData.Funcscfg_wxxcx && myPageData.Funcscfg_wxxcx.length > 0) {
    myPageData.Funcscfg_wxxcx.forEach((item, index) => {
      if (myTemp.bottomBtnCount < 5) {
        if (item.xcxid && item.xcxname && item.xcxpath) {
          myTemp.bottomBtnCount++;

          $(`.btn_xcx_more${index} .icon`).attr("src", item.xcxicon || 'https://assets.rurushishi.com/yq-rs-h5/xcxicon3.png');
          $(`.btn_xcx_more${index} .txt`).html(item.xcxname);
          $(".btn_xcx_more" + index).css("display", "block");
          var mpPath = item.xcxpath;
          if (mpPath.substring(0, 1) != "/") {
            mpPath = "/" + mpPath;
          }
          mpPath = wj.addUrlParamFromObj(mpPath, {
            gzhOpenid: myTemp.openid,
            pageid: myPageData.PageId
          })

          let script = document.createElement("script");
          script.type = "text/wxtag-template";
          script.text = `<div style="width:${document.body.clientWidth / myTemp.bottomBtnCount}px;height:60px;"></div>`;
          let html = `<wx-open-launch-weapp class="btn_xcx_more${index}_mp_launch_wx" username="${item.xcxid}" path="${mpPath}">${script.outerHTML}</wx-open-launch-weapp>`;
          $(".btn_xcx_more" + index + "_mp_launch").html(html);

          $(".btn_xcx_more" + index + "_mp_launch_wx").on('launch', function (e) {
            window.AddCount(100001 + index, {
              funcname: item.xcxname
            })
          });
        }
      }
    })
  }
}

if (myTemp.bottomBtnCount == 0) {
  $(".page .bottom").addClass("hide");
}

/**
 * bind data
 */
//绑定内容
if (myPageData.Imgs && myPageData.Imgs.length > 0) {
  $(".images_content").removeClass("hide")
  $(".arrow").addClass("hide");
  myPageData.Imgs.forEach(function (e, i) {
    $(".images_content").append("<div class='images_content_imgwarp'><img src=" + e.filepath + "></div>");
  });

  // 图片内容 slide 不要删除
  // $(".swiper-container").removeClass("hide")
  // myPageData.Imgs.forEach(function (e, i) {
  //   $(".swiper-wrapper").append("<div class='swiper-slide'><img src=" + e.filepath + "></div>");
  // });
  // if (parseInt(myPageData.PageId) >= 22994) {
  //   var tmpSwiperWarpperImgs = $(".swiper-wrapper img");
  //   if (tmpSwiperWarpperImgs && tmpSwiperWarpperImgs.length > 0) {
  //     tmpSwiperWarpperImgs = Array.prototype.slice.call(tmpSwiperWarpperImgs);
  //     tmpSwiperWarpperImgs.forEach(function (e) {
  //       e.style.height = "auto";
  //       e.style.position = "absolute";
  //       e.style.left = "0px";
  //       e.style.clip = `rect(0px,${myTemp.windowWidth}px,${myTemp.windowHeight}px,0px)`;
  //     })
  //   }
  // }
} else if (myPageData.Imagetext && myPageData.Imagetext != "") {
  // 图文内容
  // $(".page").css("overflow", "scroll");
  $(".arrow").addClass("hide");
  $(".image-text-warp").removeClass("hide");
  var imgText = decodeURIComponent(myPageData.Imagetext.replace(/[+]/g, "%20")).replace(/padding:0 5px;/g, "");
  imgText = imgText.replace(/height:[\s]?[0-9.]*px[\s]?!important;/g, "height: auto!important;");
  imgText = imgText.replace(/preview.html\?width=[0-9]*[&]?(amp;)?height=[0-9]*[&]?(amp;)?/g, "preview.html?");
  $(".image-text_content").append(imgText);
  beautifyImageText();

} else if (myPageData.Video) {
  // 视频内容
  var videoFullScreen = document.querySelector("#videoFullScreen");
  videoFullScreen.src = myPageData.Video;
  videoFullScreen.poster = myPageData.Videoposter;
  $(".arrow").addClass("hide");
  $(".full-screen-video").removeClass("hide");
  if (wj.browser.versions.ios) {
    document.addEventListener("WeixinJSBridgeReady", function () {
      var intervalVideo = setInterval(function () {
        if (videoFullScreen.paused) {
          videoFullScreen.play();
        } else {
          clearInterval(intervalVideo)
        }
      }, 1000)
    }, false);
  } else {
    $(".full-screen-video").on("click", function () {
      videoFullScreen.play();
    });
  }
}

function beautifyImageText() {
  var audios = $(".rs-audio");
  audios.each(function (i, e) {
    $(e).css("display", "none");
    var audio_title = $(e).attr("rs-title");
    if (!audio_title || audio_title == undefined) {
      audio_title = null;
    }
    var audio_warp = document.createElement("div");
    audio_warp.className = "audio_warp";
    audio_warp.innerHTML = '<div class="left">' +
      '<div class="btn audio_control' + i + '">' +
      '</div>' +
      '</div>' +
      '<div class="right">' +
      '<strong class="share_audio_title">' + (audio_title || "没有标题") +
      '</strong>' +
      '<span class="share_audio_tips db">来自如是</span>' +
      '<span class="db share_audio_progress_wrp">' +
      '<span class="db share_audio_progress share_audio_progress' + i + '">' +
      '<span class="share_audio_progress_inner share_audio_progress_inner' + i + '"></span>' +
      '<span class="share_audio_progress_buffer"></span>' +
      '<span class="share_audio_progress_loading share_audio_progress_loading' + i + '" style="display:none;">' +
      '<span class="share_audio_progress_loading_inner"></span>' +
      '</span>' +
      '</span>' +
      '<span class="share_audio_progress_handle share_audio_progress_handle' + i + '" style="display:none;left:0%;">' +
      '</span>' +
      '<span class="share_audio_desc db" aria-labelledby="时长">' +
      '<em  class="share_audio_length_current share_audio_length_current' + i + '" aria-hidden="true">00:00</em>' +
      '<em  class="share_audio_length_total share_audio_length_total' + i + '">00:00</em>' +
      '</span>' +
      '</span>' +
      '</div>';

    var audioTemp = {
      TimeLength: 0,
      PlayTime: 0,
      Interval: null,
      ProgressWidth: 0,
      HandleIsFirstTouch: true,
      HandleOriginalStartX: 0,
      HandleOriginalStartY: 0,
    };
    e.preload = "auto";
    e.muted = true;
    e.play();
    setTimeout(function () {
      e.muted = false;
      e.pause();
      e.currentTime = 0;
    }, 100)
    e.onloadedmetadata = function () {
      $(".share_audio_length_total" + i).html(formatAudioTime(e.duration));
      audioTemp.TimeLength = parseInt(e.duration);
    }

    $(audio_warp).find(".btn").on("click", function () {
      if (myTemp.img_text.audioList.length > 0) {
        myTemp.img_text.audioList.forEach(function (audioObj, audioIndex) {
          if (audioObj.audioIndex != i) {
            clearInterval(audioObj.interval);
            $("audio")[audioObj.audioIndex].pause();
            $(".audio_control" + audioObj.audioIndex).removeClass("audio_play");
          }
        })
      }

      audioTemp.ProgressWidth = $(audio_warp).find(".share_audio_progress" + i).width();
      if (e.readyState == 3) {
        $(".share_audio_progress_loading" + i).css({
          "display": "block"
        });
        e.muted = true;
        e.play();
        var temp1 = setInterval(function () {
          if (parseInt(e.currentTime) > 1) {
            e.muted = false;
            e.pause();
            e.currentTime = 0;
            $(audio_warp).find(".btn").tap();
            clearInterval(temp1);
          }
        }, 100)
      } else if (e.readyState == 2 || e.readyState == 4) {
        e.muted = false;
        $(".share_audio_progress_loading" + i).css({
          "display": "none"
        });
        if (e.paused) {
          e.play();
          $(this).addClass("audio_play");
          $(".share_audio_progress_handle" + i).css({
            "display": "block"
          });
          var that = this;
          audioTemp.Interval = setInterval(function () {
            if (audioTemp.PlayTime < audioTemp.TimeLength) {
              audioTemp.PlayTime++;
              $(".share_audio_progress_inner" + i).css({
                "width": (audioTemp.PlayTime / audioTemp.TimeLength) * 100 + "%"
              })
              $(".share_audio_progress_handle" + i).css({
                "left": (audioTemp.PlayTime / audioTemp.TimeLength) * 100 + "%"
              })

              $(".share_audio_length_current" + i).html(formatAudioTime(audioTemp.PlayTime));
            } else {
              $(that).removeClass("audio_play");
              audioTemp.PlayTime = 0;
              clearInterval(audioTemp.Interval);
              $(".share_audio_progress_inner" + i).css({
                "width": (audioTemp.PlayTime / audioTemp.TimeLength) * 100 + "%"
              })
              $(".share_audio_progress_handle" + i).css({
                "left": (audioTemp.PlayTime / audioTemp.TimeLength) * 100 + "%"
              })
              $(".share_audio_length_current" + i).html("00:00");
            }
          }, 1000)
          var obj = {
            interval: audioTemp.Interval,
            audioIndex: i
          }
          myTemp.img_text.audioList.push(obj);
        } else {
          clearInterval(audioTemp.Interval);
          e.pause();
          $(this).removeClass("audio_play");
        }
      }
    })

    $(audio_warp).find(".share_audio_progress_handle" + i).on("touchstart", function (event) {
      console.log("touchstart");
      console.log(event);
      if (audioTemp.HandleIsFirstTouch) {
        audioTemp.HandleIsFirstTouch = false;
        audioTemp.HandleOriginalStartX = event.originalEvent.touches[0].clientX;
        audioTemp.HandleOriginalStartY = event.originalEvent.touches[0].clientY;
      }

    })

    $(audio_warp).find(".share_audio_progress_handle" + i).on("touchmove", function (event) {

      console.log("ontouchmove");
      console.log(event);
      var clientX = event.originalEvent.touches[0].clientX;
      var scale = 0;
      if (audioTemp.HandleOriginalStartX <= clientX && clientX < (audioTemp.HandleOriginalStartX + audioTemp.ProgressWidth)) {
        var temp = clientX - audioTemp.HandleOriginalStartX;
        scale = (temp / audioTemp.ProgressWidth) * 100;
        $(this).css({
          "left": scale + "%"
        })
        $(".share_audio_progress_inner" + i).css({
          "width": scale + "%"
        })
        audioTemp.PlayTime = (scale * audioTemp.TimeLength) / 100;
        $(".share_audio_length_current" + i).html(formatAudioTime(audioTemp.PlayTime));
        e.currentTime = audioTemp.PlayTime;
        if (e.paused) {
          $(audio_warp).find(".btn").tap();
        }
      }


    })
    $(audio_warp).find(".share_audio_progress_handle" + i).on("touchend", function (event) {
      console.log("ontouchend");
      console.log(event);
    })


    $(e).after(audio_warp);

  })
}

function formatAudioTime(time) {
  var ss = parseInt(time);
  var s = parseInt(ss % 60);
  if (s < 10) {
    s = "0" + s;
  }
  var m = parseInt(ss / 60);
  if (m < 10) {
    m = "0" + m;
  }
  var h = parseInt(ss / 6000);
  if (h > 1) {
    return h + ":" + m + ":" + s;
  } else {
    return m + ":" + s;
  }
}


// 20201225不在采用这个逻辑了
//绑定致电电话
// if (wj.qs("ucallphone")) {
//   $(".btn_zd_a").attr("href", "tel:" + wj.qs("ucallphone"));
// }
// else if (myPageData.Propcall) {
//   //在上传在线信息之后会调用getRegistUserMobile();
// } else {
//   $(".btn_zd_a").attr("href", "tel:" + myPageData.Tel);
// }
function getRegistUserMobile() {
  // 20201225不在采用这个逻辑了
  return;
  $.ajax({
    type: "GET",
    url: api.wx,
    data: {
      j: JSON.stringify({
        "action": "/hb/HbH5Action/getUserUpFans",
        "requestParam": {
          "pageid": parseInt(myPageData.PageId),
          "refereeopenid": myTemp.refereeopenid
        },
        "openid": myTemp.openid,
        "passport": myTemp.passport,
        "url": location.href
      })
    },
    success: function (data) {
      myTemp.isGetUpUserMobile = true;
      if (data && data.obj) {
        myTemp.receiveMsgOpenId = data.obj;
        window.comreq.getUserInfo(function (data) {
          const userInfo = data.obj;
          let isSale = userInfo && userInfo.user && userInfo.user.cardno && userInfo.role && userInfo.role.length
          console.log(isSale);
          // 没有srcuid 并且自身为销售时
          if (!wj.qs('rscuid') && isSale) return
          $.ajax({
            type: "GET",
            url: api.wx,
            data: {
              j: JSON.stringify({
                "action": "/global/User/getRegistUserMobile",
                "requestParam": {
                  "openid": myTemp.receiveMsgOpenId
                },
                "openid": myTemp.openid,
                "passport": myTemp.passport,
                "url": location.href
              })
            },
            success: function (data) {
              if (data && data.obj) {
                myTemp.upUserMobile = data.obj;
                if (wj.isMobileNumber(myTemp.upUserMobile)) {
                  $(".btn_zd_a").attr("href", "tel:" + myTemp.upUserMobile);
                } else {
                  $(".btn_zd_a").attr("href", "tel:" + myPageData.Tel);
                }
              }
            }
          });
        }, myTemp.openid)
      } else {
        $(".btn_zd_a").attr("href", "tel:" + myPageData.Tel);
      }
    }
  });
}

//绑定官微客服电话
$(".call_href").attr("href", "tel:" + myPageData.Tel);
//绑定官微二维码
$(".qrcode_img").attr("src", myPageData.WxQrcode);
//绑定官微微信号
$(".qrcode_wxno").text(myPageData.WxCode);
//绑定官微客服图片
$(".customservice_img").attr("src", myPageData.CsPic ? myPageData.CsPic : "http://assets.rurushishi.com/h5/img/customservice.png");

//点击致电
$(".btn_zd").on("click", function () {
  AddCount(1);
  removeBottomAllActiveClass(this)
  let phone = myTemp.saleCardUser && myTemp.saleCardUser.info && myTemp.saleCardUser.info.ui && myTemp.saleCardUser.info.ui.mobile || myPageData.Tel || '';
  if (phone) {
    location.href = `tel:${phone}`;
  } else {
    alert('未配置默认电话')
  }
})
//点击客服咨询
$(".btn_zx").on("click", function () {
  removeBottomAllActiveClass(this)
  // 去除点击咨询按钮时的统计
  // AddCount(2);
  myPageData.Chat = `${location.protocol}//${location.host}/marketies/rc/cus-service.html`;
  myPageData.Chat = wj.addUrlParamFromObj(myPageData.Chat, {
    mobile: myPageData.Tel || '',
    referenceopenid: myTemp.refereeopenid || '',
    pageid: myPageData.PageId
  })
  location.href = myPageData.Chat;
})
//点击调研
$(".btn_dy").on("click", function () {
  removeBottomAllActiveClass(this)
  AddCount(3);
  //http://ddipctest.rushinews.com/web/ui/direction.html?page=rs1&classId=22464177237760&questionnaireId=22464176998656&tacheItemId=22464177249025
  // "appid": "asdf",//如是
  //     "openid": "asdf",//如是
  //     "pageid":1,//如是 页面id
  //     "correlationuserid": "sdf",//ddi userid
  //     "correlationextendid": "asfasdf",//ddi 问卷 tacheItemId
  //     "platformtype": 1,
  if (myTemp.processinstanceid) {
    myPageData.Survey += `&processinstanceid=${myTemp.processinstanceid}`;
  }
  wj.openUrl(myPageData.Survey);
});

(function () {
  if (myPageData.Wpageid && myPageData.Mall) {
    var tmpStr = `&ptype=t1&pageid=${myPageData.PageId}&openid=${myTemp.openid}&passport=${myTemp.passport}&refereeopenid=${myTemp.refereeopenid}&projectid=${myPageData.Pid}&apihost=${cfg.apihost}&host=${location.host}`;
    if (myTemp.psn) {
      tmpStr += "&psn=" + myTemp.psn;
    }
    if (myTemp.share_api) {
      tmpStr += "&share_api=" + encodeURIComponent(myTemp.share_api);
    }
    let requestParamData = {
      "url": myPageData.Mall + tmpStr
    }
    var insetPageUrlData = {
      openid: myTemp.openid,
      passport: myTemp.passport,
      "url": location.href,
      "action": "/wicre/WicreAction/insetPageUrl",
      "requestParam": requestParamData
    };
    $.ajax({
      type: "GET",
      url: api.wx,
      async: true,
      data: {
        j: JSON.stringify(insetPageUrlData),
        t: 6
      },
      success: function (data) {
        if (data && data.obj) {
          myPageData.MallNew = data.obj;
        }
      }
    });
  }
})();
//点击商城
$(".btn_sc").on("click", function () {
  removeBottomAllActiveClass(this)
  AddCount(4);
  // 根据myPageData.wpageid判断是否是微创商城
  if (myPageData.Wpageid) {
    if (myPageData.MallNew) {
      location.href = myPageData.MallNew;
    } else {
      setInterval(() => {
        if (myPageData.MallNew) {
          location.href = myPageData.MallNew;
        }
      }, 100);
    }
  } else {
    location.href = myPageData.Mall;
  }
})
//点击直播
$(".btn_live").on("click", function () {
  removeBottomAllActiveClass(this)
  AddCount(7);
  location.href = myPageData.LiveUrl;
})
//点击特惠
$(".btn_th").on("click", function () {
  removeBottomAllActiveClass(this)
  // $(".fav").css({
  //   height: "17rem"
  // });
  $(".writePhone").css({
    height: "8rem"
  });
  if (wj.browser.versions.ios) {

    document.getElementById("inputPhoneId").addEventListener('focus', () => {
      // 记录当前位置
      myTemp.scrollY2675 = window.scrollY;
      myTemp.suspendSelfTimer = true;
    })
    document.getElementById("inputPhoneId").addEventListener('blur', () => {
      if (myTemp.suspendSelfTimer) {
        myTemp.suspendSelfTimer = false;
        // 还原位置
        window.scrollTo({ top: myTemp.scrollY2675 || 0, left: 0, behavior: "smooth" })
      }
    })

    document.getElementById("inputPhoneId").focus();
  } else {
    setTimeout(() => {
      document.getElementById("inputPhoneId").focus();
    }, 500);
  }
})

// 新版留电
$(".writePhoneClose").on("click", function () {
  $(".writePhone").css({
    height: "0rem"
  });
})
$(".btnSubmitPhone").on("click", function () {
  var strPhone = $(".inputPhone").val();
  if (strPhone == "") {
    alert("请先填写手机号！");
  } else if (!wj.isMobileNumber(strPhone)) {
    alert("手机号格式不正确");
  } else {
    $(".writePhone").css({
      height: "0rem"
    });
    var data = {
      phone: strPhone,
      pageid: myPageData.PageId,
      refereeopenid: myTemp.refereeopenid,
      openid: myTemp.openid
    }
    if (myTemp.rscuid) {
      data.rscuid = myTemp.rscuid;
    }
    if (myTemp.ipv6) data.ipv6 = myTemp.ipv6
    yqAnalytics.setUserInfo({
      openId: myTemp.openid,
      phoneNumber: strPhone
    })
    biz.handlerYqAnalyticsEvent('entryPhoneNumber', {
      phoneNumber: strPhone,
      type: 1,
      bizSource: 1
    })
    $.ajax({
      type: "POST",
      url: api.h5 + "act=entry",
      data: data,
      success: function () {
        alert("留电成功！");
      }
    });
    if (myTemp.isWxworkGroupMsg) {
      comreq.qywxGroupMsg(3);
    }
  }
})

//点击特惠-数字按钮
$(".mytd").each(function (i, e) {
  if (i < 9) {
    $(e).on("click", function () {
      enterNum(i);
    })
  }
});
$(".td11").on("click", function () {
  enterNum(-1);
})

function enterNum(i) {
  var str = $(".input").text();
  if (!wj.isNumber(str)) {
    str = "";
  }
  $(".input").text(str + "" + (i + 1) + "");
}

$(".td12").on("click", function () {
  var str = $(".input").text();
  if (str == "") {
    str = "输入您的电话获得专属服务";
  } else if (wj.isNumber(str) && str.length > 1) {
    str = str.substring(0, str.length - 1);
  } else if (str.length == 1) {
    str = "输入您的电话获得专属服务";
  }
  $(".input").text(str);
})
$(".td12").on("taphold", function () {
  $(".input").text("输入您的电话获得专属服务");
})
//点击特惠-提交 已不用
$(".btn_submit").on("click", function () {
  var strPhone = $(".input").text();
  if (strPhone == "" || strPhone == "输入您的电话获得专属服务") {
    alert("请先填写手机号或电话号！");
  } else if (!wj.isMobileNumber(strPhone)) {
    alert("请填写正确格式的手机号或电话号！");
  } else {
    $(".fav").css({
      height: "0rem"
    });
    var data = {
      phone: strPhone,
      pageid: myPageData.PageId,
      channelid: wj.qs("ch", true),
      refereeopenid: myTemp.refereeopenid,
      openid: myTemp.openid
    }
    if (myTemp.rscuid) {
      data.rscuid = myTemp.rscuid;
    }
    if (myTemp.ipv6) data.ipv6 = myTemp.ipv6
    $.ajax({
      type: "POST",
      url: api.h5 + "act=entry",
      data: data,
      success: function () {
        alert("留电成功！");
      }
    });
  }
});
//点击导航
$(".btn_dh").on("click", function () {
  removeBottomAllActiveClass(this)
  AddCount(5);
  // location.href = myPageData.NavUrl;
  let urlParam = wj.getParamFromUrl(myPageData.NavUrl);
  let longitude = urlParam.position.split(',')[0];
  let latitude = urlParam.position.split(',')[1];
  wx.openLocation({
    latitude: parseFloat(latitude), // 纬度，浮点数，范围为90 ~ -90
    longitude: parseFloat(longitude), // 经度，浮点数，范围为180 ~ -180。
    name: urlParam.name || '', // 位置名
    address: '', // 地址详情说明
    scale: 16, // 地图缩放级别,整形值,范围从1~28。默认为最大
    infoUrl: '' // 在查看位置界面底部显示的超链接,可点击跳转
  });
})
//点击 官微
$(".btn_gw").on("click", function () {
  if (cfg.isLoc) {
    if (cfg.helpShowWx % 2 == 0) {
      $(".wx_number").addClass("hide");
      $(".wx_qrcode").removeClass("hide");
    } else {
      $(".wx_qrcode").addClass("hide");
      $(".wx_number").removeClass("hide");
    }
  } else {
    if (wj.browser.versions.wxGroup) {
      $(".wx_number").addClass("hide");
      $(".wx_qrcode").removeClass("hide");
    } else {
      $(".wx_qrcode").addClass("hide");
      $(".wx_number").removeClass("hide");
    }
  }
  removeBottomAllActiveClass(this)
  $(".wx").css({
    height: "15rem"
  });
  cfg.helpShowWx++;
})
//点击 留言
$(".btn_record").on("click", function () {
  removeBottomAllActiveClass(this)
  $(".record").css({
    height: "14rem"
  });
  $(".msg_content").html(myPageData.Record);
});
//点击 晒照
$(".btn_photo").on("click", function () {
  $(".photo").on('touchmove', function (e) {
    e.preventDefault();
  }, false);
  removeBottomAllActiveClass(this)
  AddCount(6);
  $(".photo").css({
    height: "20rem"
  });
  document.getElementsByTagName("body")[0].style.overflow = "hidden";
  document.getElementsByTagName("body")[0].style.maxHeight = "100vh";
  $(".msg_content").html(myPageData.Record);
});

// 第一个默认给橙色
// console.log($('.reset-item').first().hasClass('btn_luckdraw'));
// console.log($('.reset-item').first().hasClass('btn_th'));
// if ($('.btn_luckdraw').css('display') == 'block') {
//   $('.btn_luckdraw').addClass('orangeactive')
// }
// if ($('.reset-item').first().hasClass('btn_luckdraw')) {
//   $('.reset-item').first().addClass('orangeactive')
// } else {
//   $('.reset-item').first().addClass('active')
// }
function removeBottomAllActiveClass(btn) {
  $('.reset-item').each(function () {
    let childs = $(this).children('svg');
    if (childs.length > 0) {
      if (childs[0].innerHTML.indexOf('-active') > -1) {
        childs[0].innerHTML = childs[0].innerHTML.replace('-active', '');
      }
    }
  })
  let childs = $(btn).children('svg');
  if (childs.length > 0) {
    if (childs[0].innerHTML.indexOf('#icon-') > -1) {
      let iconClassName = childs[0].innerHTML.match(/#icon-[a-z]*/)[0];
      childs[0].innerHTML = childs[0].innerHTML.replace(iconClassName, iconClassName + '-active');
    }
  }
}

//点击 留言弹出框-留言
myTemp.record_localId = 0;
myTemp.record_timer = null;
myTemp.record_timer_num = 1;
$(".record_btn_img").on("click", function () {
  if (myTemp.isRecordIng == 0) {
    myTemp.isRecordIng = 1
    myTemp.record_timer_num = 1;
    myTemp.record_timer = setInterval(function () {
      if (myTemp.record_timer_num % 2 == 0) {
        $(".record_btn_img").attr("src", "http://assets.rurushishi.com/h5/img/record_btn.png");

      } else {
        $(".record_btn_img").attr("src", "http://assets.rurushishi.com/h5/img/record_btn_ing.png");
      }
      myTemp.record_timer_num++;
    }, 500)
    wx.startRecord();
  } else if (myTemp.isRecordIng == 1) {
    myTemp.isRecordIng = 0;
    $(".record_btn_img").attr("src", "http://assets.rurushishi.com/h5/img/record_btn.png");
    clearInterval(myTemp.record_timer);
    $(".msg").removeClass("hide");
    wx.stopRecord({
      success: function (res) {
        var localId = res.localId;

      }
    });
  }
});
//点击 晒照弹出框 上传
document.getElementById("fileToUpload").addEventListener("change", function (event) {
  if (typeof FileReader == "undefined") {
    alert("您的浏览器不支持图像上传！");
  }
  $(".face-cut_ok").text("确 认");
  UploadImg(this.files[0]);
  event.target.value = '';
});

function UploadImg(file) {
  if (!file) {
    return;
  }
  var reader = new FileReader();
  reader.readAsDataURL(file);
  reader.onloadend = function (e) {
    myTemp.sendImgBaseData = this.result;
    if (myTemp.imgFaceCut == null) {
      myTemp.imgFaceCut = $('.face-cut_container >img');
      myTemp.imgFaceCut.attr("src", myTemp.sendImgBaseData);
      myTemp.imgFaceCut.cropper({
        aspectRatio: 9 / 9,
        crop: function (data) {

        }
      });
    } else {
      myTemp.imgFaceCut.cropper('replace', myTemp.sendImgBaseData);
    }
    $(".face-cut").removeClass("hide");
    closeCard();
    // function cut() {
    //     var $imgData = $img.cropper('getCroppedCanvas')
    //     var dataurl = $imgData.toDataURL('image/png');
    //     console.log(dataurl)
    // }

  }
}

$(".face-cut_ok").on("click", function () {
  if ($(".face-cut_ok").text() == "上传中...") {
    return;
  }
  var tmpImgData = myTemp.imgFaceCut.cropper('getCroppedCanvas')
  myTemp.sendImgBaseData = tmpImgData.toDataURL('image/png');
  $(".face-cut_ok").text("上传中...");
  canvasDataURL(myTemp.sendImgBaseData, {
    maxSize: 600,
    quality: 1
  }, function (myData) {
    myTemp.sendImgBaseData = myData;
    console.log(myTemp.sendImgBaseData)
    $.ajax({
      type: "post",
      url: api.wx,
      data: {
        j: JSON.stringify({
          "openid": myTemp.openid,
          "passport": myTemp.passport,
          "action": "/ai/face/FaceAction/upload",
          "requestParam": {
            "obj": {
              "device": "wx",
              "base64img": myTemp.sendImgBaseData.split(',')[1],
              "projectid": myPageData.Pid,
              pageid: parseInt(myPageData.PageId)
            }
          }
        })
      },
      success: function (data) {
        if (data && data.code == 0 && data.obj) {
          if (data.errmsg == "上传成功") {
            $(".msg_content").html(myTemp.photoRewardConfig.uploadoktext || data.errmsg)
          } else {
            $(".msg_content").html(data.errmsg)
          }
          $(".msg").removeClass("hide");
          $(".msg_title").on("click", function () {
            $(".face-cut").addClass("hide");
          })
        } else {
          $(".msg_content").html(data.errmsg || '上传失败！')
          $(".msg").removeClass("hide");
          $(".msg_title").on("click", function () {
            $(".face-cut").addClass("hide");
          })
        }
      }
    });
  })
})


$(".face-cut_cancel").on("click", function () {
  $(".face-cut").addClass("hide");
})
$(".face-cut_rotate").on("click", function () {
  myTemp.imgFaceCut.cropper('rotate', 90);
})

function canvasDataURL(path, obj, callback) {
  var img = new Image();
  img.src = path;
  img.onload = function () {
    var that = this;
    // 默认按比例压缩
    var w = that.width,
      h = that.height,
      scale = w / h;
    if (w <= obj.maxSize) {
      return callback(path)
    }
    if (obj.maxSize) {
      if (w > h) {
        w = obj.maxSize;
        h = w / scale;
      } else {
        h = obj.maxSize;
        w = h * scale;
      }
    } else {
      w = obj.width || w;
      h = obj.height || (w / scale);
    }

    var quality = 0.7; // 默认图片质量为0.7
    //生成canvas
    var canvas = document.createElement('canvas');
    var ctx = canvas.getContext('2d');
    // 创建属性节点
    var anw = document.createAttribute("width");
    anw.nodeValue = w;
    var anh = document.createAttribute("height");
    anh.nodeValue = h;
    canvas.setAttributeNode(anw);
    canvas.setAttributeNode(anh);
    ctx.drawImage(that, 0, 0, w, h);
    if (wj.browser.versions.ios) {
      // canvas.width = h;
      // canvas.height = w;
      // ctx.rotate(90 * Math.PI / 180);
      // ctx.drawImage(this, 0, 0, w, -h);
    }
    // 图像质量
    if (obj.quality && obj.quality <= 1 && obj.quality > 0) {
      quality = obj.quality;
    }
    // quality值越小，所绘制出的图像越模糊
    var base64 = canvas.toDataURL('image/jpeg', quality);
    // 回调函数返回base64的值
    callback(base64);
  }
}

//关闭弹出框
$(".msg_title").on("click", function () {
  $(".msg").addClass("hide");
});
//点击 页面内容 关闭功能片
$(".swiper-slide").on("click", function () {
  closeCard();
})
$(".image-text").on("click", function () {
  closeCard();
});
$(".full-screen-video").on("click", function () {
  closeCard();
});

function closeCard() {
  $(".fav").css({
    height: "0rem"
  });
  $(".writePhone").css({
    height: "0rem"
  });
  $(".wx").css({
    height: "0rem"
  });
  $(".record").css({
    height: "0rem"
  });
  $(".photo").css({
    height: "0rem"
  });
  document.getElementsByTagName("body")[0].style.overflow = "";
  document.getElementsByTagName("body")[0].style.maxHeight = "";
}

//初始化Swiper
var mySwiper = new Swiper('.swiper-container', {
  effect: 'slide',//可设置为'slide'（普通切换、默认）,"fade"（淡入）"cube"（方块）"coverflow"（3d流）"flip"（3d翻转）。
  direction: 'vertical',
  lazyLoading: true,
  mousewheelControl: true,
  watchSlidesProgress: true,
  onInit: function (swiper) {
    swiper.myactive = 0;
  },
  onProgress: function (swiper) {
    for (var i = 0; i < swiper.slides.length; i++) {
      var slide = swiper.slides[i];
      var progress = slide.progress;
      var translate, boxShadow, scale, boxShadowOpacity, es;

      translate = progress * swiper.height * 0.8;
      scale = 1 - Math.min(Math.abs(progress * 0.2), 1);
      boxShadowOpacity = 0;

      slide.style.boxShadow = '0px 0px 10px rgba(0,0,0,' + boxShadowOpacity + ')';

      if (i == swiper.myactive) {
        es = slide.style;
        es.webkitTransform = es.MsTransform = es.msTransform = es.MozTransform = es.OTransform = es.transform = 'translate3d(0,' + (translate) + 'px,0) scale(' + scale + ')';
        es.zIndex = 0;
      } else {
        es = slide.style;
        es.webkitTransform = es.MsTransform = es.msTransform = es.MozTransform = es.OTransform = es.transform = '';
        es.zIndex = 1;
      }
    }
  },
  onTransitionEnd: function (swiper, speed) {
    for (var i = 0; i < swiper.slides.length; i++) { }

    swiper.myactive = swiper.activeIndex;

  },
  onSetTransition: function (swiper, speed) {

    for (var i = 0; i < swiper.slides.length; i++) {

      var es = swiper.slides[i].style;
      es.webkitTransitionDuration = es.MsTransitionDuration = es.msTransitionDuration = es.MozTransitionDuration = es.OTransitionDuration = es.transitionDuration = speed + 'ms';

    }

  },
  onSlideChangeEnd: function (swiper) {
    if (swiper.activeIndex == swiper.slides.length - 1) {
      $(".arrow").addClass("hide");
    } else {
      $(".arrow").removeClass("hide");
    }

    if (swiper.activeIndex == 1) {

    }

    AddHit(myPageData.Imgs[swiper.activeIndex].id);
    SendImgTime(myPageData.Imgs[swiper.activeIndex].id);
  }
});

//统计点击
// 打开小程序从100001（含）开始，另外增加了一个 funcname 字段（小程序的名称）
window.AddCount = function (type, addP) {
  if (myPageData.PageId) {
    var postData = {
      atype: type,
      pageid: myPageData.PageId,
      openid: myTemp.openid,
      refereeopenid: myTemp.refereeopenid
    };
    if (addP) {
      postData = {
        ...postData,
        ...addP
      }
    }
    if (myTemp.rscuid) {
      postData.rscuid = myTemp.rscuid;
    }
    if (myTemp.ipv6) postData.ipv6 = myTemp.ipv6
    $.ajax({
      type: "POST",
      url: api.h5 + "act=adv",
      data: postData
    });
  }
}

//统计在线时长
function SendTime(callback) {
  if (myPageData.PageId) {
    var data = {
      openid: myTemp.openid,
      pageid: myPageData.PageId,
      tempid: myTemp.guid,
      channelid: wj.qs("ch", true),
      refereeopenid: myTemp.refereeopenid,
      projectid: myPageData.Pid
    };
    if (myTemp.psn) {
      data.psn = myTemp.psn;
    }
    if (myTemp.rscuid) {
      data.rscuid = myTemp.rscuid;
    }
    if (myTemp.ipv6) data.ipv6 = myTemp.ipv6
    $.ajax({
      type: "POST",
      url: api.h5 + "act=ip",
      data: data,
      complete: function () {

        // if (!myTemp.rscuid || myTemp.rscuid == myTemp.openid) { }
        if (!myTemp.isAlreadyAfterActIpGetConsultingLink) {
          // setSpreadChat(true);
        }
        if (myPageData.Propcall && !myTemp.isGetUpUserMobile) {
          getRegistUserMobile();
        }

        if (callback) {
          callback();
        }
      }
    });
  }
}
if ((wj.browser.versions.wxGroup && myTemp.openid) || !wj.browser.versions.wxGroup) {
  setTimeout(function () {
    SendTime();
    setInterval(SendTime, 3000);
  }, 1000)
}
if (myTemp.isWxworkGroupMsg) {
  comreq.qywxGroupMsg(1);
}
//统计查看每张图片的次数和时长
if (myPageData.Imgs && myPageData.Imgs.length > 0) {
  AddHit(myPageData.Imgs[0].id); //记录第一张图片
  SendImgTime(myPageData.Imgs[0].id); //记录第一张图片
  //自动统计每张图片时长
  setInterval(SendPageno, 3000);
}
function AddHit(imgId) {
  if (myPageData.PageId) {
    var data = {
      id: imgId,
      refereeopenid: myTemp.refereeopenid,
      openid: myTemp.openid,
    };
    if (myTemp.rscuid) {
      data.rscuid = myTemp.rscuid;
    }
    if (myTemp.ipv6) data.ipv6 = myTemp.ipv6
    $.ajax({
      type: "POST",
      url: api.h5 + "act=doc",
      data: data
    });
  }
}

function SendImgTime(imgId) {
  tmpImgTimeImgId = imgId;
  if (!tmpImgTimeObj[imgId]) {
    tmpImgTimeObj[imgId] = 1;
    SendPageno(1);
  }
}
function SendPageno(timelength) {
  timelength = timelength || 3;
  if (myPageData.PageId && tmpImgTimeImgId > 0) {
    tmpImgTimeObj[tmpImgTimeImgId] += 3;
    var data = {
      pageid: myPageData.PageId,
      pageno: tmpImgTimeImgId,
      timelength: timelength,
      refereeopenid: myTemp.refereeopenid,
      openid: myTemp.openid,
      tempid: myTemp.guid,
    };
    if (myTemp.psn) {
      data.psn = myTemp.psn;
    }
    if (myTemp.rscuid) {
      data.rscuid = myTemp.rscuid;
    }
    if (myTemp.ipv6) data.ipv6 = myTemp.ipv6
    $.ajax({
      type: "POST",
      url: api.h5 + "act=pageno",
      data: data
    });
  }
}

function uploadLocation(latitude, longitude, speed, accuracy) {
  $.ajax({
    type: "GET",
    url: api.wx,
    data: {
      j: JSON.stringify({
        "action": "/hb/HbPageReaderDistributionAction/add",
        "requestParam": {
          "openid": myTemp.openid,
          "latitude": latitude,
          "longitude": longitude,
          "pageid": myPageData.PageId,
          "pid": myPageData.Pid
        },
        "openid": myTemp.openid,
        "passport": myTemp.passport,
        "url": location.href
      })
    },
    success: function (data) {

    }
  });
}


function wxShare() {
  if (myPageData.PageId) {
    var data = {
      openid: myTemp.openid,
      pageid: myPageData.PageId,
      refereeopenid: myTemp.refereeopenid
    };
    if (myTemp.psn) {
      data.psn = myTemp.psn;
    }
    if (myTemp.rscuid) {
      data.rscuid = myTemp.rscuid;
    }
    if (myTemp.ipv6) data.ipv6 = myTemp.ipv6
    $.ajax({
      type: "POST",
      url: api.h5 + "act=share",
      data: data,
      complete: function () { }
    });

    var shareLibOption = {
      pageid: parseInt(myPageData.PageId),
      openid: myTemp.openid,
      passport: myTemp.passport,
      apiurl: api.wx.replace("?", ""),
      refereeopenid: myTemp.refereeopenid,
    }
    if (myTemp.psn) {
      shareLibOption.psn = myTemp.psn
    }
    if (myPageData.Showsharepage == 1) {
      ShareLibSDK.showShareWin(shareLibOption)
    }
    biz.handlerYqAnalyticsEvent('share')

    if (myTemp.isWxworkGroupMsg) {
      comreq.qywxGroupMsg(2);
    }
  }
}

var isSendClientInfo = 0;
function sendClientInfo() {
  if (myPageData.PageId) {
    var formater = new UAFormat();
    var formaterResult = formater.getResult();
    var mobileModel = formaterResult.device.model;
    var mobileVendor = formaterResult.device.vendor;
    var mobileType = formaterResult.device.type;
    if (mobileModel == "iPhone") {
      mobileModel = MobileDevice.getModels().join(' or ');
      // iPhone X、iPhone XS
      var isIPhoneX = /iphone/gi.test(window.navigator.userAgent) && window.devicePixelRatio && window.devicePixelRatio === 3 && window.screen.width === 375 && window.screen.height === 812;
      // iPhone XS Max
      var isIPhoneXSMax = /iphone/gi.test(window.navigator.userAgent) && window.devicePixelRatio && window.devicePixelRatio === 3 && window.screen.width === 414 && window.screen.height === 896;
      // iPhone XR
      var isIPhoneXR = /iphone/gi.test(window.navigator.userAgent) && window.devicePixelRatio && window.devicePixelRatio === 2 && window.screen.width === 414 && window.screen.height === 896;
      if (isIPhoneX) {
        mobileModel = 'iPhone X';
      }
      if (isIPhoneXSMax) {
        mobileModel = 'iPhone XS Max';
      }
      if (isIPhoneXR) {
        mobileModel = 'iPhone XR';
      }
    } else if (mobileModel == "unknown") {
      var u = navigator.userAgent
      var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1 || u.indexOf('Adr') > -1; //g
      var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
      if (isAndroid) {
        mobileType = 'mobile'
        var sss = u.split(";");
        for (var k = 0; k < sss.length; k++) {
          if (sss[k].indexOf("Build/") > -1) {
            mobileModel = sss[k].split("Build/")[0]
            mobileVendor = '';
          }
        }
      }
      else if (isIOS) {
        mobileType = 'ios mobile'
      } else {
        mobileType = 'Browser'
      }
    }
    if (mobileVendor.indexOf("ZTE ") > -1) {
      mobileVendor = "ZTE";
    }
    var data = {
      info: wj.clientInfo,
      pageid: myPageData.PageId,
      refereeopenid: myTemp.refereeopenid,
      model: mobileModel,
      vendor: mobileVendor,
      type: mobileType,
      openid: myTemp.openid,
    };
    if (myTemp.psn) {
      data.psn = myTemp.psn;
    }
    if (myTemp.rscuid) {
      data.rscuid = myTemp.rscuid;
    }
    if (myTemp.ipv6) data.ipv6 = myTemp.ipv6
    $.ajax({
      type: "POST",
      url: api.h5 + "act=mt",
      data: data,
      complete: function () {
        isSendClientInfo = 1;
        clearInterval(intervalClientInfo);
      }
    });
    if (mobileModel.indexOf("iPhone X") > -1) {
      $(".page .bottom").css("padding-bottom", "0.5rem");
    }
  }
}
var intervalClientInfo = setInterval(function () {
  if (isSendClientInfo == 0) {
    sendClientInfo();
  }
}, 1000);


function initIScroll() {

  // var windowHeight = $(window).innerHeight();
  //
  // $(".image-text").css({
  //     height: windowHeight
  // });
  new IScroll('.image-text-warp', {
    useTransition: true,
    click: true
  });
}

function getCount() {
  $.ajax({
    type: "GET",
    url: api.wx,
    data: {
      j: JSON.stringify({
        "action": "/hb/HbH5Action/pageCounter",
        "requestParam": {
          obj: {
            "id": parseInt(myPageData.PageId)
          }
        },
        "openid": myTemp.openid,
        "passport": myTemp.passport,
        "url": location.href
      })
    },
    success: function (data) {
      if (data && data.obj && data.obj.length > 0) {
        data.obj.forEach(function (item) {
          if (item.type == "shares") {
            myTemp.countShares = item.count;
          } else if (item.type == "pv") {
            myTemp.countPv = item.count;
          } else if (item.type == "likes") {
            myTemp.likes = item.count;
          } else if (item.type == "islike") {
            myTemp.islike = item.count;
          }
        })
        // 定制阅读和分享数据
        if (myPageData.PageId == 156728) {
          myTemp.countPv += 6000;
          myTemp.countShares += 4000;
        } else if (myPageData.PageId == 146814) {
          myTemp.countPv += 4000;
          myTemp.countShares += 600;
        } else if (myPageData.PageId == 162703) {
          myTemp.countPv += 1500;
          myTemp.countShares += 400;
          myTemp.likes += 300;
        } else if (myPageData.PageId == 167845) {
          myTemp.countPv += 1300;
          myTemp.countShares += 410;
          myTemp.likes += 268;
        } else if (myPageData.PageId == 176502) {
          myTemp.countPv += 3000;
          myTemp.countShares += 630;
          myTemp.likes += 270;
        }

        // 顶部统计数据
        // if (myPageData.Showpv && myPageData.Showpv == 1) {
        //   $(".count_pv span").text("阅读" + myTemp.countPv + "次")
        //   $(".count_pv").removeClass("hide")
        // }
        // if (myPageData.Showshares && myPageData.Showshares == 1) {
        //   $(".count_shares span").text("" + myTemp.countShares + "次")
        //   $(".count_shares").removeClass("hide")
        // }

        // 底部统计数据
        if (myPageData.Showpv && myPageData.Showpv == 1) {
          $(".footer_left_see").removeClass("hide");
          $(".image-text_footer-pv").text(myTemp.countPv);
          if (myPageData.PageId == 59000) {
            $(".image-text_footer-pv").text("10万+");
          }
        }
        if (myPageData.Showshares && myPageData.Showshares == 1) {
          $(".footer_left_share").removeClass("hide");
          $(".image-text_footer-sharecount").text(myTemp.countShares);
        }
        if (myPageData.Wxstyle) {
          $(".footer_left_like").removeClass("hide");
          if (myTemp.islike > 0) {
            $(".image-text_footer-xin").attr("src", "http://assets.rurushishi.com/h5/img/foot_xin_2.png");
          }
          $(".image-text_footer-praise-count").text(myTemp.likes);
        }

      }
    }
  });
}

$(".rich_media_meta_nickname,.gzh_name span,.gzh_btn").on("click", function (e) {
  e.preventDefault();
  $(".wx-qrcode .text").html(myPageData.Wxaccountname);
  $(".wx-qrcode .qr").attr("src", myPageData.WxQrcode);
  $(".wx-qrcode .tips").html("扫码关注公众号");
  $(".wx-qrcode").removeClass("hide");
})

$(".close").on("click", function (e) {
  $(".wx-qrcode").addClass("hide");
})
$(".image-text_footer_btn").on("click", function () {
  if (myTemp.islike > 0) {

  } else {
    // 点赞
    // $(".image-text_footer-praise-count").text(myTemp.likes + 1);
    $(".image-text_footer-xin").attr("src", "http://assets.rurushishi.com/h5/img/foot_xin_2.png");
    $.ajax({
      type: "GET",
      url: api.wx,
      data: {
        j: JSON.stringify({
          "action": "/hb/HbH5Action/likePage",
          "requestParam": {
            "pageid": parseInt(myPageData.PageId),
            "rfopenid": myTemp.refereeopenid
          },
          "openid": myTemp.openid,
          "passport": myTemp.passport,
          "url": location.href
        })
      },
      success: function (data) {
      }
    });

  }
})
if (myPageData.Wxaccountname) {
  $(".wx-qrcode .text").html(myPageData.Wxaccountname + "公众号")
}
if (myPageData.WxQrcode) {
  $(".wx-qrcode .qr").attr("src", myPageData.WxQrcode)
}
if (myPageData.gzh_headimg) {
  $(".gzh_img img").attr("src", myPageData.gzh_headimg);
} else {
  // 默认的公众号头像
  $(".gzh_img img").attr("src", "https://assets.rurushishi.com/web1001/wxf1efeb9b9d6f6f06/1571218299000-69.png");
}
if (myPageData.Wxstyle) {
  getCount();
  $(".image-text_header h2").html(myPageData.BrowserTabTitle || myPageData.WxShare.Title);
  $("#post-date,.page_date").html(myPageData.Articledate)
  $(".rich_media_meta_nickname,.gzh_name span").html(myPageData.Wxaccountname)
  $(".image-text_header").removeClass("hide");
  $(".image-text_footer").removeClass("hide");
  if (myPageData.PageId == "109831") {
    $(".gzh_img img").attr("src", "https://assets.rurushishi.com/web1001/wxf1efeb9b9d6f6f06/1577697671000-15.jpeg");
  } else if (myPageData.PageId == "92472") {
    $(".gzh_img img").attr("src", "https://assets.rurushishi.com/web1001/wxf1efeb9b9d6f6f06/1576720886000-88.jpeg");
  } else if (myPageData.PageId == "80825") {
    $(".gzh_img img").attr("src", "https://assets.rurushishi.com/web1001/wxf1efeb9b9d6f6f06/1576149849000-48.jpeg");
  } else if (myPageData.PageId == "71528") {
    $(".gzh_img img").attr("src", "https://assets.rurushishi.com/web1001/wxf1efeb9b9d6f6f06/1574672834000-70.jpeg");
  } else if (myPageData.PageId == "65561") {
    $(".gzh_img img").attr("src", "https://assets.rurushishi.com/web1001/wxf1efeb9b9d6f6f06/1571715755000-92.jpeg");
  } else if (myPageData.PageId == "68931") {
    $(".gzh_img img").attr("src", "https://assets.rurushishi.com/web1001/wxf1efeb9b9d6f6f06/1573733831000-69.jpeg");
  } else if (myPageData.PageId == "66647") {
    $(".gzh_img img").attr("src", "https://assets.rurushishi.com/web8174/wx62d1eb9f0fc231fc/1572362729000-14.jpeg");
  } else if (myPageData.PageId == "68621") {
    $(".gzh_img img").attr("src", "https://assets.rurushishi.com/web1001/wxf1efeb9b9d6f6f06/1573624355000-51.png");
  }
}
if (myPageData.Cancomment) {
  $(".discuss").removeClass("hide");
  // 点击写留言
  $(".leave_word").on("click", function () {
    $(".editor").text('');
    history.pushState(null, '', '');
    $(".board").fadeIn();
  })
  window.onpopstate = function (event) {
    $(".board").fadeOut();
  };
  // 提交留言
  $(".leaving").on("click", function () {
    var strTxt = $(".editor").text();
    if (strTxt.length == 0) {
      alert("留言不能为空")
      return;
    }
    $.ajax({
      type: "GET",
      url: api.wx,
      data: {
        j: JSON.stringify({
          "action": "/global/Comment/save",
          "requestParam": {
            obj: {
              pageid: myPageData.PageId,
              content: strTxt,
            }
          },
          "openid": myTemp.openid,
          "passport": myTemp.passport,
          "url": location.href
        })
      },
      success: function (data) {
        if (data && data.obj && data.obj == 1) {
          getCommentList();
          $(".board").fadeOut();
        } else {
          alert("不支持emoji表情输入！");
        }
      }
    });

  })
  getCommentList();

  function getCommentList() {
    $.ajax({
      type: "GET",
      url: api.wx,
      data: {
        j: JSON.stringify({
          "action": "/global/Comment/getCommentList",
          "requestParam": {
            obj: {
              "pageid": myPageData.PageId,
            },
            "offset": 0,
            "size": 1000
          },
          "openid": myTemp.openid,
          "passport": myTemp.passport,
          "url": location.href
        })
      },
      success: function (data) {
        if (data && data.obj && data.obj.list && data.obj.list.length > 0) {
          dealGetCommentList(data.obj.list);
          // initIScroll();
        }
        if (!wj.browser.versions.wxGroup && !cfg.isLoc) {
          //非微信环境不能点赞和评论
          $(".praise").addClass("hide");
        }
      }
    });
  }
  if (!wj.browser.versions.wxGroup && !cfg.isLoc) {
    //非微信环境不能点赞和评论
    $(".leave_word").addClass("hide");
  }

  function dealGetCommentList(listPar) {
    var strHtml = "";
    var list = [];
    for (var i = 0; i < listPar.length; i++) {
      if (listPar[i].ismine) {
        list.splice(0, 0, listPar[i]);
      } else {
        list.push(listPar[i]);
      }
    }


    for (var i = 0; i < list.length; i++) {
      var item = list[i];
      strHtml += ` <div class="item" id="item${item.id}">
        <div class="head">
            <img src="${item.headimgurl || 'http://assets.rurushishi.com/h5/img/default_head.jpg'}">
        </div>
        <div class="result">
            <div class="author">
                <div class="text">
                    <div class="nickname">${item.nickname || '默认用户'}</div>
                    <div class="message">${item.content}</div>
                    <div class="oper">
                        <span class="time">${wj.formatDateLikeWx(wj.getFullTime(item.createdtime))}</span> 
                        ${item.ismine ? `
                            <span class="del" data-id="${item.id}" >删除</span>
                            `: ""}
                    </div>
                </div>
                <div class="praise">
                    <div class="praise_inside" data-id="${item.id}">
                        <img id="praise${item.id}" data-id="${item.id}" src="${item.islike ? 'http://assets.rurushishi.com/h5/img/wx_praise.png' : 'http://assets.rurushishi.com/h5/img/wx_unpraise.png'}">
                        <span id="praiseCount${item.id}" data-id="${item.id}" class="praise_count">${item.like}</span>
                    </div>
                 </div>
            </div>

             ${item.isreply ? `
                <div class="auditor">
                <div class="text">
                    <div class="nickname">
                        作者回复</div>
                    <div class="message">${item.replycomment.content}</div>
                    <div class="oper">
                        <span class="time">${wj.formatDateLikeWx(wj.getFullTime(item.replycomment.createdtime))}</span> 
                    </div>
                </div>
                <div class="praise">
                     <div class="praise_inside" data-id="${item.replycomment.id}">
                        <img id="praise${item.replycomment.id}" data-id="${item.replycomment.id}"  src="${item.replycomment.islike ? 'http://assets.rurushishi.com/h5/img/wx_praise.png' : 'http://assets.rurushishi.com/h5/img/wx_unpraise.png'}">
                        <span id="praiseCount${item.replycomment.id}" data-id="${item.replycomment.id}"  class="praise_count">${item.replycomment.like}</span>
                    </div>
                 </div>
            </div>
             `: ''}
        </div>
            </div>`;
    }
    $(".discuss_content").html(strHtml);
    // 点赞
    $(".praise_inside").on("click", function (e) {
      var id = e.target.dataset.id;
      var islike = -1;
      var praiseObj = $("#praise" + id);
      var praiseCountObj = $("#praiseCount" + id);
      var parseCount = parseInt(praiseCountObj.text());
      if (praiseObj.attr("src").indexOf("unpraise") > -1) {
        islike = 1;
      } else {
        islike = 0;
      }
      if (islike) {
        praiseObj.attr("src", "http://assets.rurushishi.com/h5/img/wx_praise.png");
        praiseCountObj.text(parseCount + 1);
      } else {
        praiseObj.attr("src", "http://assets.rurushishi.com/h5/img/wx_unpraise.png");
        praiseCountObj.text(parseCount - 1);
      }

      $.ajax({
        type: "GET",
        url: api.wx,
        data: {
          j: JSON.stringify({
            "action": "/global/Comment/doLikeComment",
            "requestParam": {
              "id": parseInt(id),
              islike: islike
            },
            "openid": myTemp.openid,
            "passport": myTemp.passport,
            "url": location.href
          })
        },
        success: function (data) {

        }
      });
    })


    // 删除
    $(".oper .del").on("click", function (e) {
      var id = e.target.dataset.id;
      $("#item" + id).fadeOut();
      $.ajax({
        type: "GET",
        url: api.wx,
        data: {
          j: JSON.stringify({
            "action": "/global/Comment/delete",
            "requestParam": {
              isdelete: 1,
              "id": parseInt(id),
              ispc: 0
            },
            "openid": myTemp.openid,
            "passport": myTemp.passport,
            "url": location.href
          })
        },
        success: function (data) {

          // getCommentList();
        }
      });
    })
  }
}

// 解决pc端打开页面字体大小问题
if (!(wj.browser.versions.ios || wj.browser.versions.android)) {
  $(".image-text_content").css("font-size", "16px")
}


if (myPageData.PageId == "922") {
  getCount();
  $(".image-text_header h2").html(myPageData.WxShare.Title);
  $("#post-date").html("2018-03-29")
  $(".rich_media_meta_nickname").html("太原泰禾")
  $(".wx-qrcode .text").html("泰禾太原公众号")
  $(".wx-qrcode .qr").attr("src", "http://assets.rurushishi.com/h5/img/taihe-taiyaun.jpg")
  $(".image-text_header").removeClass("hide");
  $(".image-text_footer").removeClass("hide");
  $(".image-text_footer-praise-count").text(parseInt(myTemp.countPv / 10) + 1)
}
if (myPageData.PageId == "970") {
  getCount();
  $(".image-text_header h2").html(myPageData.WxShare.Title);
  $("#post-date").html("2018-04-02")
  $(".rich_media_meta_nickname").html("太原泰禾")
  $(".wx-qrcode .text").html("泰禾太原公众号")
  $(".wx-qrcode .qr").attr("src", "http://assets.rurushishi.com/h5/img/taihe-taiyaun.jpg")
  $(".image-text_header").removeClass("hide");
  $(".image-text_footer").removeClass("hide");
  $(".image-text_footer-praise-count").text(parseInt(myTemp.countPv / 10) + 1)
}
if (myPageData.PageId == "974") {
  getCount();
  $(".image-text_header h2").html(myPageData.WxShare.Title);
  $("#post-date").html("2018-04-03")
  $(".rich_media_meta_nickname").html("太原泰禾")
  $(".wx-qrcode .text").html("泰禾太原公众号")
  $(".wx-qrcode .qr").attr("src", "http://assets.rurushishi.com/h5/img/taihe-taiyaun.jpg")
  $(".image-text_header").removeClass("hide");
  $(".image-text_footer").removeClass("hide");
  $(".image-text_footer-praise-count").text(parseInt(myTemp.countPv / 10) + 1)
}
if (myPageData.PageId == "1011") {
  getCount();
  $(".image-text_header h2").html(myPageData.WxShare.Title);
  $("#post-date").html("2018-04-09")
  $(".rich_media_meta_nickname").html("太原泰禾")
  $(".wx-qrcode .text").html("泰禾太原公众号")
  $(".wx-qrcode .qr").attr("src", "http://assets.rurushishi.com/h5/img/taihe-taiyaun.jpg")
  $(".image-text_header").removeClass("hide");
  $(".image-text_footer").removeClass("hide");
  $(".image-text_footer-praise-count").text(parseInt(myTemp.countPv / 10) + 1)
}
if (myPageData.PageId == "1055") {
  getCount();
  $(".image-text_header h2").html(myPageData.WxShare.Title);
  $("#post-date").html("2018-04-13")
  $(".rich_media_meta_nickname").html("太原泰禾")
  $(".wx-qrcode .text").html("太原泰禾公众号")
  $(".wx-qrcode .qr").attr("src", "http://assets.rurushishi.com/h5/img/taihe-taiyaun.jpg")
  $(".image-text_header").removeClass("hide");
  $(".image-text_footer").removeClass("hide");
  $(".image-text_footer-praise-count").text(parseInt(myTemp.countPv / 10) + 1)
}
if (myPageData.PageId == "1097") {
  getCount();
  $(".image-text_header h2").html(myPageData.WxShare.Title);
  $("#post-date").html("2018-04-14")
  $(".rich_media_meta_nickname").html("太原泰禾")
  $(".wx-qrcode .text").html("太原泰禾公众号")
  $(".wx-qrcode .qr").attr("src", "http://assets.rurushishi.com/h5/img/taihe-taiyaun.jpg")
  $(".image-text_header").removeClass("hide");
  $(".image-text_footer").removeClass("hide");
  $(".image-text_footer-praise-count").text(parseInt(myTemp.countPv / 10) + 1)
}
if (myPageData.PageId == "1125") {
  getCount();
  $(".image-text_header h2").html(myPageData.WxShare.Title);
  $("#post-date").html("2018-04-17")
  $(".rich_media_meta_nickname").html("太原泰禾")
  $(".wx-qrcode .text").html("泰禾太原公众号")
  $(".wx-qrcode .qr").attr("src", "http://assets.rurushishi.com/h5/img/taihe-taiyaun.jpg")
  $(".image-text_header").removeClass("hide");
  $(".image-text_footer").removeClass("hide");
  $(".image-text_footer-praise-count").text(parseInt(myTemp.countPv / 10) + 1)
}
if (myPageData.PageId == "1139") {
  getCount();
  $(".image-text_header h2").html(myPageData.WxShare.Title);
  $("#post-date").html("2018-04-18")
  $(".rich_media_meta_nickname").html("太原泰禾")
  $(".wx-qrcode .text").html("泰禾太原公众号")
  $(".wx-qrcode .qr").attr("src", "http://assets.rurushishi.com/h5/img/taihe-taiyaun.jpg")
  $(".image-text_header").removeClass("hide");
  $(".image-text_footer").removeClass("hide");
  $(".image-text_footer-praise-count").text(parseInt(myTemp.countPv / 10) + 1)
}
if (myPageData.PageId == "1163") {
  getCount();
  $(".image-text_header h2").html(myPageData.WxShare.Title);
  $("#post-date").html("2018-04-20")
  $(".rich_media_meta_nickname").html("太原泰禾")
  $(".wx-qrcode .text").html("泰禾太原公众号")
  $(".wx-qrcode .qr").attr("src", "http://assets.rurushishi.com/h5/img/taihe-taiyaun.jpg")
  $(".image-text_header").removeClass("hide");
  $(".image-text_footer").removeClass("hide");
  $(".image-text_footer-praise-count").text(parseInt(myTemp.countPv / 10) + 1)
}
if (myPageData.PageId == "1165") {
  getCount();
  $(".image-text_header h2").html(myPageData.WxShare.Title);
  $("#post-date").html("2018-04-19")
  $(".rich_media_meta_nickname").html("太原泰禾")
  $(".wx-qrcode .text").html("泰禾太原公众号")
  $(".wx-qrcode .qr").attr("src", "http://assets.rurushishi.com/h5/img/taihe-taiyaun.jpg")
  $(".image-text_header").removeClass("hide");
  $(".image-text_footer").removeClass("hide");
  $(".image-text_footer-praise-count").text(parseInt(myTemp.countPv / 10) + 1)
}
if (myPageData.PageId == "992") {
  getCount();
  $(".image-text_header h2").html(myPageData.WxShare.Title);
  $("#post-date").html("2018-04-03")
  $(".rich_media_meta_nickname").html("泰禾郑州")
  $(".wx-qrcode .text").html("泰禾郑州公众号")
  $(".wx-qrcode .qr").attr("src", "http://assets.rurushishi.com/h5/img/taihe-zhengzhou.jpg")
  $(".image-text_header").removeClass("hide");
  $(".image-text_footer").removeClass("hide");
  $(".image-text_footer-praise-count").text(parseInt(myTemp.countPv / 10) + 1)
}
if (myPageData.PageId == "1003") {
  getCount();
  $(".image-text_header h2").html(myPageData.WxShare.Title);
  $("#post-date").html("2018-04-04")
  $(".rich_media_meta_nickname").html("泰禾郑州")
  $(".wx-qrcode .text").html("泰禾郑州公众号")
  $(".wx-qrcode .qr").attr("src", "http://assets.rurushishi.com/h5/img/taihe-zhengzhou.jpg")
  $(".image-text_header").removeClass("hide");
  $(".image-text_footer").removeClass("hide");
  $(".image-text_footer-praise-count").text(parseInt(myTemp.countPv / 10) + 1)
}
if (myPageData.PageId == "1063") {
  getCount();
  $(".image-text_header h2").html(myPageData.WxShare.Title);
  $("#post-date").html("2018-04-12")
  $(".rich_media_meta_nickname").html("泰禾郑州")
  $(".wx-qrcode .text").html("泰禾郑州公众号")
  $(".wx-qrcode .qr").attr("src", "http://assets.rurushishi.com/h5/img/taihe-zhengzhou.jpg")
  $(".image-text_header").removeClass("hide");
  $(".image-text_footer").removeClass("hide");
  $(".image-text_footer-praise-count").text(parseInt(myTemp.countPv / 10) + 1)
}
if (myPageData.PageId == "1082") {
  getCount();
  $(".image-text_header h2").html(myPageData.WxShare.Title);
  $("#post-date").html("2018-04-13")
  $(".rich_media_meta_nickname").html("泰禾郑州")
  $(".wx-qrcode .text").html("泰禾郑州公众号")
  $(".wx-qrcode .qr").attr("src", "http://assets.rurushishi.com/h5/img/taihe-zhengzhou.jpg")
  $(".image-text_header").removeClass("hide");
  $(".image-text_footer").removeClass("hide");
  $(".image-text_footer-praise-count").text(parseInt(myTemp.countPv / 10) + 1)
}
if (myPageData.PageId == "1145") {
  getCount();
  $(".image-text_header h2").html(myPageData.WxShare.Title);
  $("#post-date").html("2018-04-17")
  $(".rich_media_meta_nickname").html("泰禾郑州")
  $(".wx-qrcode .text").html("泰禾郑州公众号")
  $(".wx-qrcode .qr").attr("src", "http://assets.rurushishi.com/h5/img/taihe-zhengzhou.jpg")
  $(".image-text_header").removeClass("hide");
  $(".image-text_footer").removeClass("hide");
  $(".image-text_footer-praise-count").text(parseInt(myTemp.countPv / 10) + 1)
}
if (myPageData.PageId == "1037") {
  getCount();
  $(".image-text_header h2").html(myPageData.WxShare.Title);
  $("#post-date").html("2018-04-17")
  $(".rich_media_meta_nickname").html("越秀逸境")
  $(".wx-qrcode .text").html("越秀逸境公众号")
  $(".wx-qrcode .qr").attr("src", "http://assets.rurushishi.com/h5/img/yuexiuyijing.jpg")
  $(".image-text_header").removeClass("hide");
  $(".image-text_footer").removeClass("hide");
  $(".image-text_footer-praise-count").text(parseInt(myTemp.countPv / 10) + 1)
}

if (myPageData.PageId == "22924") {
  $(".image-text").css({
    "width": "100%",
    "margin-left": "0",
    "margin-top": "0"
  })
}

//活动邀约
if (myPageData.Act_invite == 1) {


  $.ajax({
    type: "GET",
    url: api.wx,
    data: {
      j: JSON.stringify({
        "action": "/workflow/WFAction/updateIsReadActivityInfo",
        "requestParam": {
          "pageid": parseInt(myPageData.PageId)
        },
        "openid": myTemp.openid,
        "passport": myTemp.passport,
        "url": location.href
      })
    },
    success: function (data) {

    }
  });

  $.ajax({
    type: "GET",
    url: api.wx,
    data: {
      j: JSON.stringify({
        "action": "/workflow/WFAction/getActUser",
        "requestParam": {
          "pageid": parseInt(myPageData.PageId),
          "projectid": parseInt(myPageData.Pid),
        },
        "openid": myTemp.openid,
        "passport": myTemp.passport,
        "url": location.href
      })
    },
    success: function (data) {
      $(".invite").removeClass("hide");
      if (data && data.obj && data.obj.isjoin == 1) {
        $(".btnJoin").html("已参加")
      } else {
        $(".btnJoin").on("click", function () {
          if ($(".btnJoin").html() != "已参加") {
            joinAct();
          }
        })
      }
    }
  });

}
function joinAct() {

  $.ajax({
    type: "GET",
    url: api.wx,
    data: {
      j: JSON.stringify({
        "action": "/workflow/WFAction/joinAct",
        "requestParam": {
          obj: {
            "projectid": parseInt(myPageData.Pid),
            "pageid": parseInt(myPageData.PageId),
            "activityname": decodeURIComponent(wj.qs("actname"))
          }
        },
        "openid": myTemp.openid,
        "passport": myTemp.passport,
        "url": location.href
      })
    },
    success: function (data) {
      if (data && data.obj && data.obj == 1) {
        $(".btnJoin").html("已参加")
        alert("确认参加成功！")
      }
    }
  });
}





(function () {

  var appUserCard = {
    cookieKeys: {
      cardid: "usercard2_cardid",
      uuid: "usercard2_uuid",
      masteropenid: "usercard2_masteropenid",
      projectid: "usercard2_projectid"
    },
    cookieDuration: 60 * 3,
    logInfo: {
      cardid: '',
      uuid: '',
      masteropenid: '',
      projectid: '',
    }
  }
  initUserCard();
  function initUserCard() {
    appUserCard.logInfo.cardid = wj.cookie.get(appUserCard.cookieKeys.cardid);
    appUserCard.logInfo.uuid = wj.cookie.get(appUserCard.cookieKeys.uuid);
    appUserCard.logInfo.masteropenid = wj.cookie.get(appUserCard.cookieKeys.masteropenid);
    appUserCard.logInfo.projectid = wj.cookie.get(appUserCard.cookieKeys.projectid);
    if (appUserCard.logInfo.cardid && appUserCard.logInfo.uuid && appUserCard.logInfo.masteropenid && appUserCard.logInfo.projectid) {
      userCardLog();
      setInterval(userCardLog, 5000);
    }

  }
  function userCardLog() {
    $.ajax({
      type: "GET",
      url: api.wx,
      data: {
        j: JSON.stringify({
          "action": "/electroniccard/ElectronicCardAction/saveCardLog",
          "requestParam": {
            obj: {
              cardid: appUserCard.logInfo.cardid,//电子名片模板id
              uuid: appUserCard.logInfo.uuid,//前端生成的唯一标识
              masteropenid: appUserCard.logInfo.masteropenid,//当前电子名片所属人的openid
              projectid: appUserCard.logInfo.projectid,
              referenceopenid: myTemp.refereeopenid
            }
          },
          "openid": myTemp.openid,
          "passport": myTemp.passport,
          "url": location.href
        })
      },
      success: function (data) {

      }
    });
  }
})();

// 增加自行动功能片
window.addSelfFun = function () {
  if (myTemp.isOpenSelfAction) {
    if (myTemp.saleCardUser.info.openid) {
      $(".btn_seft_img").attr("src", myTemp.saleCardUser.info.ui.headimg)
    } else {
      $(".btn_seft_img").attr("src", 'https://assets.rurushishi.com/yq-rs-h5/t1/self-default-headimg.png')
    }

    let btns = $(".bt_comm").children();
    let arrBtnIndex = [];
    for (let i = 0; i < btns.length; i++) { if (btns[i].style.display == 'block') arrBtnIndex.push(i); }
    if (arrBtnIndex.length == 5) {
      $(btns[arrBtnIndex[4]]).remove();
      arrBtnIndex.splice(4, 1)
    }
    let beforeBtnIndex = -1;
    if (arrBtnIndex.length == 1) {
      beforeBtnIndex = arrBtnIndex[0]
    } else if (arrBtnIndex.length == 2) {
      beforeBtnIndex = arrBtnIndex[0]
    } else if (arrBtnIndex.length == 3) {
      beforeBtnIndex = arrBtnIndex[2]
    } else if (arrBtnIndex.length == 4) {
      beforeBtnIndex = arrBtnIndex[1]
    }
    if (beforeBtnIndex > -1) {
      $(".btn_seft").css("display", "block");
      $(btns[beforeBtnIndex]).after($(".btn_seft"))
    } else {
      $(".btn_seft").css("display", "block");
    }

    let str = "Hi，您好...";
    let tmpInterval4159 = setInterval(() => {
      let txt = $(".btn_seft_txt").text();
      if (txt == str) {
        clearInterval(tmpInterval4159)
        setTimeout(() => {
          $(".btn_seft_txt").addClass("hide");
          $(".btn_seft_txt_after").addClass("hide");
        }, 5000);
      } else {
        $(".btn_seft_txt").text(str.substring(0, txt.length + 1));
      }
    }, 300);

    $(".btn_seft").on("click", function () {
      myTemp.stopSelfTimer = true;
      window.setShareLibSDK(2);
    })
  }
  // 展示底部功能片
  $(".bt_comm").removeClass("hide");
}
// 内容自行动
window.setContentSelf = function () {
  let self_action_time = 15;//15秒 3的倍数
  let self_action_count = 0;//当前计时时长
  // 先判断是否开启内容自行动
  $.ajax({
    type: "GET",
    url: api.wx,
    data: {
      j: JSON.stringify({
        "action": "/sales/pageselfconfig/getPageSelfConfig",
        "requestParam": {
          obj: {
            pageid: myPageData.PageId
          }
        },
        "openid": myTemp.openid,
        "passport": myTemp.passport,
        "url": location.href
      })
    },
    success: function (data) {

      if (data && wj.isObject(data.obj)) {
        myTemp.isOpenSelfAction = 1;
      }
      window.addSelfFun();
      myTemp.isOpenEncourage = window.myPageData.Other.cfg_markting;

      // 只有在配置了无门槛全民营销文章
      if (myTemp.isOpenEncourage) {
        if (myTemp.issubscribe) {
          if (myTemp.query.from == 'gzhmsg') {
            window.myVue.clickShowEncourageBox();
          }
        }

        comreq.getMyInviteCount().then(res => {
          if (res.code === 0) {
            let waitingInviteCount = res.data.marktingSalesLeadCount - res.data.inviteCount;
            // 且在推荐人有好友可赠送礼品 判断文章状态：
            if (myTemp.issubscribe && waitingInviteCount > 0) {

              comreq.judgementShare({
                pageid: myPageData.PageId,
                refereeopenid: myTemp.openid
              }).then(res => {
                console.log('judgementShare', res)
                // 1、当文章是用户之前分享过的文章，则弹出提示给好友赠送礼品；
                if (res.data) {
                  window.myVue.clickShowEncourageBox();
                } else {
                  // 2、当文章是用户未分享过的文章，则不主动弹出提示给好友赠送，但右下角的礼品icon增加抖动效果，用户点击之后直接跳转到赠送礼品的页面
                  $(".encourage").addClass("fast")
                  myTemp.isBtnEncourageGoInvitePage = true;
                }
              })
            } else {
              // 当未开启内容自行动时，保持15秒弹出无门槛全民营销的弹窗；
              if (!myTemp.isOpenSelfAction && myTemp.isOpenEncourage) {
                if (myTemp.query.from != 'gzhmsg') {
                  setTimeout(() => {
                    if (!(myTemp.userIntegralInfo && (myTemp.userIntegralInfo.isSale || myTemp.userIntegralInfo.isAgentType4))) {
                      window.myVue.clickShowEncourageBox();
                    }
                  }, 1000 * 15);
                }
              } else if (myTemp.isOpenSelfAction) {
                initSelf();
              }
            }
          }
        })
      } else if (myTemp.isOpenSelfAction) {
        initSelf();
      }
    }
  });

  function initSelf() {
    let zxdObj = wj.cookie.get("t1_20180910_self_" + myPageData.PageId);
    if (zxdObj && false) {
      // 如果打开过就显示小球,开启计时器等待参数初始化完成
      let tmpInterval = setInterval(function () {
        if (myPageData.PageId && myTemp.openid && myTemp.passport && myTemp.consultingLink) {
          window.setShareLibSDK(1);
          clearInterval(tmpInterval);
        }
      }, 100)
    } else {
      // 开启计时器
      let tmpInterval = setInterval(function () {
        if (myTemp.stopSelfTimer) {
          clearInterval(tmpInterval);
        }
        // 留电输入框没有弹出的情况计时
        if (!myTemp.suspendSelfTimer && !myTemp.stopSelfTimer) {
          self_action_count++;
          if (self_action_count == self_action_time && myPageData.PageId && myTemp.openid && myTemp.passport && myTemp.consultingLink) {
            window.setShareLibSDK(2);
            wj.cookie.set("t1_20180910_self_" + myPageData.PageId, "true", 365 * 24 * 60 * 60);
            clearInterval(tmpInterval);
          }
        }
      }, 1000)
    }
  }
  // type 0 默认正常弹出，1 浮球，2自定义位置
  window.setShareLibSDK = function (type) {
    if (type == 0) {
      // 播放声音
      window.ContentSelfAudio && window.ContentSelfAudio.play();
    }
    if (myPageData.PageId && myTemp.openid && myTemp.passport && myTemp.consultingLink) {
      let option = {
        pageid: myPageData.PageId,
        openid: myTemp.openid,
        refereeopenid: myTemp.refereeopenid,
        passport: myTemp.passport,
        chaturl: myTemp.consultingLink.replace("http://", location.protocol + "//"),
        apiurl: api.wx,
        type: 2
      }
      if (myTemp.psn) {
        option.psn = myTemp.psn
      }
      let btnSeft = $(".btn_seft_img").offset();
      option.top = (btnSeft.top + 8) + 'px';
      option.left = (btnSeft.left + 8) + 'px';
      // 2、当开启内容自行动，不弹出无门槛全民营销的弹窗，但内容自行动的弹窗中需要加入无门槛全民营销的文案和图片引导；
      if (myTemp.isOpenEncourage) {
        option.noThreshold = 1;
      }
      // 在有rscuid的情况把rscuid当成refereeopid传进来，不传链接上的refereeopenid参数
      let tmpInterval3858 = setInterval(() => {
        if (myTemp.saleCardUser.postOver) {
          if (myTemp.saleCardUser.openid) {
            option.refereeopenid = myTemp.saleCardUser.openid
          }
          if (cfg.isLoc) {
            clearInterval(tmpInterval3858);
          }
          ShareLibSDK.showPageSelfConfig(option)
          clearInterval(tmpInterval3858);
        }
      }, 100);
    }
  }
};

// 定制交大产投
(function () {
  if (location.host.indexOf("3ictjxy.") > -1 || cfg.isLoc || cfg.isTest) {
    let fopenid = myTemp.fopenid;
    if (fopenid) {
      let jdctFuserInfo = {};
      let myInfo = {};
      // 展示定制块
      $(".dz_jdct").removeClass("hide");
      selectHbextend(fopenid).then(function (data) {
        jdctFuserInfo = data;
        $(".de_headimg").attr("src", data.headimgurl);
        $(".demand_provide").html(data.name + '/' + data.company);
      })
      // 获取本人信息
      selectHbextend(myTemp.openid).then(function (data) {
        myInfo = data;
      })

      // 点击聊一聊
      $(".demand_chart").on("click", function () {
        jdctGetUserInfo().then(function (data) {
          if (data.user == null || data.user == '') {
            wj.openUrl(`http://${location.host}/marketies/rc/shjdclub-register.html`);
          } else {
            jdctSelectTimelenth().then(function (msg) {
              var Tmessage = encodeURIComponent(jdctFuserInfo.name + '会员您好，会员' + myInfo.name + '对您说')
              if (myPageData.BrowserTabTitle != '') {
                if (msg.timelength == 0) {
                  var Cmessage = encodeURIComponent(myInfo.company + '的' + myInfo.name + '会员，对您发布的需求' + myPageData.BrowserTabTitle + '感兴趣并给你发送了消息')
                } else {
                  var Cmessage = encodeURIComponent(myInfo.company + '的' + myInfo.name + '会员，对您发布的需求' + myPageData.BrowserTabTitle + '感兴趣，他/她阅读了' + msg.timelength + 's，并给你发送了消息')
                }
              } else {
                if (msg.timelength == 0) {
                  var Cmessage = encodeURIComponent(myInfo.company + '的' + myInfo.name + '会员，对您发布的需求感兴趣并给你发送了消息')
                }
              }
              if (location.href.indexOf("localhost") > -1 || location.href.indexOf("qmyx") > -1) {
                wj.openUrl('http://qmyx.rushinews.com/marketies/rc/rs-direction.html?type=chat&receiveropenid=' + fopenid + '&nickname=' + jdctFuserInfo.name + '&fzx=1&Tmessage=' + Tmessage + '&Cmessage=' + Cmessage)
              } else {
                wj.openUrl('http://3ictjxy.rushinews.com/marketies/rc/rs-direction.html?type=chat&receiveropenid=' + fopenid + '&nickname=' + jdctFuserInfo.name + '&fzx=1&Tmessage=' + Tmessage + '&Cmessage=' + Cmessage)
              }
            })
          }
        })
      });
      // 点击感兴趣
      $(".demand_btn").on("click", function () {
        jdctSelectTimelenth().then(function (msg) {
          var Tmessage = encodeURIComponent('小助理，' + myInfo.company + '的' + myInfo.name + '会员对您说')
          if (msg.timelength == 0) {
            var Cmessage = encodeURIComponent(myInfo.company + '的' + myInfo.name + '会员，对' + jdctFuserInfo.company + '的' + jdctFuserInfo.name + '的会员感兴趣,并给你发送了消息')
          } else {
            var Cmessage = encodeURIComponent(myInfo.company + '的' + myInfo.name + '会员，对' + jdctFuserInfo.company + '的' + jdctFuserInfo.name + '的会员感兴趣，他/她阅读了' + msg.timelength + 's，并给你发送了消息')
          }
          if (location.href.indexOf("localhost") > -1 || location.href.indexOf("qmyx") > -1) {
            wj.openUrl('http://qmyx.rushinews.com/marketies/rc/rs-direction.html?type=chat&receiveropenid=oj3y9wMHUAGHo7rpSfi-oyL-4ldY&nickname=Joann&ucallphone=18157162228&fzx=1&Tmessage=' + Tmessage + '&Cmessage=' + Cmessage)
          } else {
            wj.openUrl('http://3ictjxy.rushinews.com/marketies/rc/rs-direction.html?type=chat&receiveropenid=o66n9stPihQWBC-E7Emeya4GG4FY&nickname=Joann&ucallphone=18157162228&fzx=1&Tmessage=' + Tmessage + '&Cmessage=' + Cmessage)
          }
        })
      });

      // 获取用户的扩展信息
      function selectHbextend(fopenid) {
        return new Promise(function (resolve, reject) {
          $.ajax({
            type: "GET",
            async: true,
            url: api.wx,
            data: {
              j: JSON.stringify({
                "action": "/persid/PresidentAction/selectHbextend",
                "requestParam": {
                  openid: fopenid
                },
                "openid": myTemp.openid,
                "passport": myTemp.passport,
                "url": location.href
              })
            },
            success: function (data) {
              if (data && data.obj && data.obj.length > 0) {
                resolve(data.obj[0]);
              }
            }
          });
        })
      }

      // 获取用户信息
      function jdctGetUserInfo() {
        return new Promise(function (resolve, reject) {
          $.ajax({
            type: "GET",
            async: true,
            url: api.wx,
            data: {
              j: JSON.stringify({
                "action": "getUserinfo",
                "requestParam": {},
                "openid": myTemp.openid,
                "passport": myTemp.passport,
                "url": location.href
              })
            },
            success: function (data) {
              if (data && data.obj) {
                resolve(data.obj);
              }
            }
          });
        })
      }
      function jdctSelectTimelenth() {
        return new Promise(function (resolve, reject) {
          $.ajax({
            type: "GET",
            async: true,
            url: api.wx,
            data: {
              j: JSON.stringify({
                "action": "/persid/PresidentAction/selectTimelenth",
                "requestParam": {
                  pageid: parseInt(myPageData.PageId)
                },
                "openid": myTemp.openid,
                "passport": myTemp.passport,
                "url": location.href
              })
            },
            success: function (data) {
              if (data && data.obj) {
                resolve(data.obj);
              }
            }
          });
        })
      }
    }
  }
})();

(function () {
  if (myTemp.xcxuid && myTemp.xcxappid && myTemp.xcxprojectid && myTemp.xcxgzhappid && myTemp.openid && myTemp.passport) {
    $.ajax({
      type: "POST",
      async: true,
      url: "https://wxmp.ruthus.com/api/v1/open/bindRsGzhinfo",
      data: {
        uid: myTemp.xcxuid,
        appid: myTemp.xcxappid,
        projectid: myTemp.xcxprojectid,
        gzhAppid: myTemp.xcxgzhappid,
        gzhOpenid: myTemp.openid,
        gzhPassport: myTemp.passport
      },
      complete: function (data) {
      }
    });
  }
})();

(function () {
  if (myTemp.purephonenumber && myTemp.openid) {
    let postObj = {
      phone: myTemp.purephonenumber,
      pageid: myPageData.PageId,
      psn: myTemp.psn,
      channelid: 0,
      refereeopenid: myTemp.refereeopenid,
      openid: myTemp.openid,
      purpose: 2,//2 光速登录留电
    }
    if (myTemp.rscuid) {
      postObj.rscuid = myTemp.rscuid;
    }
    if (myTemp.ipv6) postObj.ipv6 = myTemp.ipv6
    $.ajax({
      type: "POST",
      url: api.h5 + "act=entry",
      data: postObj,
      success: function () {
      }
    });
    yqAnalytics.setUserInfo({
      openId: myTemp.openid,
      phoneNumber: myTemp.purephonenumber
    })
    biz.handlerYqAnalyticsEvent('mpPhoneNumber', {
      phoneNumber: myTemp.purephonenumber
    })
    biz.handlerYqAnalyticsEvent('entryPhoneNumber', {
      phoneNumber: myTemp.purephonenumber,
      type: 1,
      bizSource: 14
    })
  }
})();
function checkIsHaveOldMp() {
  /**
   * 悦房云 yuefangy
   * 江西万科 jxwk
   * 安联e家 alej
   * 正宏置业 zhzy
   * 联实 lianshi
   * 原圈云
   */
  var domainList = [
    // "yuefangy",
    // "jxwk",
    // "alej",
    // "zhzy",
    // "lianshi"
    // "yuanquan"
  ];
  var isHave = false;
  domainList.forEach(function (item) {
    if (location.host.indexOf(item + ".") > -1) {
      isHave = true;
    }
  })
  return isHave;
}
(function () {
  // 首页按钮逻辑
  if ((myTemp.entry == "zxslzx" || myTemp.entry == "showcenter") && myTemp.t9id && myTemp.t9psn) {
    // 在线售楼中心
    $(".btn_home img").attr("src", "https://assets.rurushishi.com/yq-rs-make/components/btn_home/home2.png?x-oss-process=image/resize,h_100,w_100")
    $(".btn_home").removeClass("hide");
    $(".btn_home").on("click", function () {
      let url = `${location.protocol}//${location.host}/${myTemp.entry == "showcenter" ? 'showcenterh5/pages/home/home' : 'h5/t9'}`;
      url += "?id=" + myTemp.t9id;
      url += "&psn=" + myTemp.t9psn;
      if (myTemp.refereeopenid) {
        url += "&refereeopenid=" + myTemp.refereeopenid;
      }
      if (myTemp.rscuid) {
        url += "&rscuid=" + myTemp.rscuid;
      }
      wj.getismp(function (ismp) {
        if (ismp && !checkIsHaveOldMp()) {
          if (myTemp.entry == 'showcenter') {
            wj.mp.rel("/pages/home/home");
          } else {
            wj.mp.rel("/pages/webview/common/common?url=" + encodeURIComponent(url));
          }
        } else {
          location.href = url;
          return false;
        }
      })
    })
  } else if (location.host.indexOf("rywlkj.") > -1) {
    // 润亿网络科技
    wj.getismp(function (ismp) {
      if (ismp) {
        // 我要看房 小程序
        $(".btn_home").removeClass("hide");
        $(".btn_home").on("click", function () {
          wj.mp.switch("/pages/rs/index/index");
        });
      }
    })
  } else if (location.host.indexOf("shxyh.") > -1) {
    // 上海星悦会
    wj.getismp(function (ismp) {
      if (ismp) {
        // 星盟Starunion 小程序
        $(".btn_home").removeClass("hide");
        $(".btn_home").on("click", function () {
          wj.mp.red("/pages/rs/index/index");
        });
      }
    })
  } else if (myTemp.entry == "tyzx") {
    // 在线体验中心
    if (location.host.indexOf("lianshi.") > -1 && myTemp.homeurl) {
      $(".btn_home img").attr("src", "http://rs.static.quanc.com.cn/lsplatform/backIndex.png")
      $(".btn_home").removeClass("hide");
      $(".btn_home").on("click", function () {
        location.href = decodeURIComponent(myTemp.homeurl);
      })
    }
  }
})();

(function () {
  if (myPageData.PageId == 120326
    || myPageData.PageId == 121634
    || myPageData.PageId == 120343
    || myPageData.PageId == 120323
    || myPageData.PageId == 121632
    || myPageData.PageId == 120324
    || myPageData.PageId == 121633
    || myPageData.PageId == 120325
    || myPageData.PageId == 120344) {
    let hdFOpenid = myTemp.fopenid;
    myPageData.Formexturl = "http://wxe1f2be0562353a76.web.ruth6666.com/act/online/blbirdact/coupon?channel=0&isshare=1";
    if (hdFOpenid) {
      myPageData.Formexturl += "&fOpenId=" + hdFOpenid;
    }
    myPageData.Formname = "购房优惠";
    if ((myPageData.Formurl || myPageData.Formexturl) && myTemp.bottomBtnCount < 5) {
      $(".btn_form").css("display", "block");
      myTemp.bottomBtnCount++;
      if (myPageData.Formname) {
        $(".btn_form .txt").html(myPageData.Formname)
      }
      $(".btn_form").on("click", function () {
        AddCount(12);
        if (myPageData.Formexturl) {
          wj.openUrl(myPageData.Formexturl);
        } else {
          wj.openUrl(myPageData.Formurl);
        }
      })
    }

    $(".btn_home2").removeClass("hide");
    $(".btn_home2").on("click", function () {
      let tmpStr = "http://wxe1f2be0562353a76.web.ruth6666.com/act/online/blbirdact/index?channel=0&isshare=1";
      if (hdFOpenid) {
        tmpStr += "&fOpenId=" + hdFOpenid;
      }
      location.href = tmpStr;
    })
    $(".bt_hdb").addClass("hide");
  }
})();


(function () {
  window.alert = function (text) {
    //解析alert内容中的换行符
    text = text.toString().replace(/\\/g, '\\').replace(/\n/g, '<br />').replace(/\r/g, '<br />');
    // 自定义DIV弹窗
    var alertdiv = '<div style="position: fixed;z-index: 1000;left: 0;right: 0;top: 0;bottom: 0;background-color: rgba(0,0,0,0.5);"><div style="position: absolute;overflow: hidden;top: 40%;left: 50%;text-align: center;line-height: 22px;background-color: #fff;border-radius: 7px;width: 280px;padding: 0;margin-left: -140px;z-index: 1000;"><div style="line-height: 46px;font-size: 18px;color: #617086;">提示</div><div style="min-height: 60px;line-height: 30px;text-align: center;padding: 0 20px;font-size: 15px;color: #595959;">' + text + '<br /></div><div style="line-height: 50px;color: #1890FF;border-top: 1px solid rgba(0, 0, 0, 0.03);font-size: 15px;" onclick="$(this).parent().parent().remove(); ">确定</div></div></div>';
    $(document.body).append(alertdiv);
  };
})();

// (function () {
//   if (wj.qs("j")) {
//     setTimeout(() => {

//       let paramObj = {
//         id: myPageData.PageId,
//         psn: myTemp.psn,
//         refereeopenid: myTemp.refereeopenid || undefined,
//         rscuid: myTemp.rscuid || undefined,
//       }
//       let newObj = {}
//       Object.keys(paramObj).forEach(key => {
//         if (paramObj[key] != undefined) {
//           newObj[key] = paramObj[key]
//         }
//       })
//       paramObj = newObj;

//       window.history.replaceState(null, null, '?' + wj.objToUrlParam(newObj))
//     }, 1000);
//   }
// })();
(function () {
  let isFavorite = false;
  function setFavorite(b) {
    isFavorite = b;
    if (b) {
      $(".favorite_img").attr("src", "https://assets.rurushishi.com/yq-rs-h5/t1/img/icon-favorite.png")
      myVue.$refs.footernew.isCollect = true
    } else {
      $(".favorite_img").attr("src", "https://assets.rurushishi.com/yq-rs-h5/t1/img/icon-no-favorite.png")
      myVue.$refs.footernew.isCollect = false
    }
  }
  if ((cfg.subdomian == 'qmyx' || cfg.subdomian == 'ajzl') && !wj.browser.versions.dy) {
    // $(".favorite").removeClass('hide');
    // 调用接口查看状态
    $.ajax({
      type: "GET",
      async: true,
      url: `${location.protocol}//${cfg.apihost}/qc-webapp/hbfavorites/list/users`,
      data: {
        appId: myTemp.appid,
        openId: myTemp.openid,
        pageId: myPageData.PageId
      },
      success: function (res) {
        // 已收藏
        if (res.code == 0 && res.data && res.data.rows && res.data.rows.length > 0) {
          setFavorite(true);
        } else {
          setFavorite(false);
        }

        $(".favorite").on("click", function () {
          if (isFavorite) {
            // 调用取消收藏
            $.ajax({
              type: "POST",
              async: true,
              url: `${location.protocol}//${cfg.apihost}/qc-webapp/hbfavorites/delete`,
              data: {
                appId: myTemp.appid,
                openId: myTemp.openid,
                pageId: myPageData.PageId
              },
              success: function (res) {
                if (res.code == 0) {
                  setFavorite(false)
                }
              }
            })
          } else {
            // 调用收藏
            $.ajax({
              type: "POST",
              async: true,
              contentType: 'application/json',
              url: `${location.protocol}//${cfg.apihost}/qc-webapp/hbfavorites`,
              data: JSON.stringify({
                appId: myTemp.appid,
                openId: myTemp.openid,
                pageId: myPageData.PageId,
                type: 2
              }),
              success: function (res) {
                if (res.code == 0) {
                  setFavorite(true)
                }
              }
            })
          }
        })
      }
    });
  }
})();

(function () {

  var tempX, x, tempY, y;

  function dragStart(e) {
    tempX = parseInt($(this).css("right") + 0);
    tempY = parseInt($(this).css("top") + 0);
    x = e.touches[0].pageX;
    y = e.touches[0].pageY;
  }

  function dragMove(e) {
    var curX = tempX - e.touches[0].pageX + x;
    var curY = tempY + e.touches[0].pageY - y;
    //边界判断
    curX = curX < 0 ? 0 : curX;
    curY = curY < 0 ? 0 : curY;
    curX = curX < document.body.clientWidth - $(this).width() ? curX : document.body.clientWidth - $(this).width();
    curY = curY < document.body.clientHeight - $(this).height() ? curY : document.body.clientHeight - $(this).height();
    $(this).css({
      "right": curX,
      "top": curY
    });
    //禁止浏览器默认事件
    e.preventDefault();
  }

  function dragEnd() {

  }
  // 传入 classname
  window.SetDragEle = function () {
    if (arguments.length > 0) {
      for (let i = 0; i < arguments.length; i++) {
        let eles = document.getElementsByClassName(arguments[i]);
        if (eles && eles.length > 0) {
          eles[0].addEventListener("touchstart", dragStart);
          eles[0].addEventListener("touchmove", dragMove);
          eles[0].addEventListener("touchend", dragEnd);
        }
      }
    }
  }

  let tmpInterval = setInterval(function () {
    let eles = document.getElementsByClassName('fload-head');
    if (eles && eles.length > 0) {
      window.SetDragEle("fload-head");
      clearInterval(tmpInterval);
    }
  }, 1000)

  window.SetDragEle("btn_luckdraw2");

})();

// 绑定微信openid到企微外部联系人帐号
(function () {
  let urlParam = wj.getParamFromUrl(location.href);
  if (urlParam.corpId && urlParam.extAccount && urlParam.fromAccount && urlParam.accountType && myTemp.openid) {
    let postParams = {
      openid: myTemp.openid,
      accountOrgid: urlParam.corpId,
      accountType: urlParam.accountType,
      appType: urlParam.appType == 1 ? 1 : 0,
      extAccount: urlParam.extAccount,
      fromAccount: urlParam.fromAccount
    }
    if (urlParam.hasOwnProperty('cfgId')) {
      postParams.cfgId = urlParam.cfgId;
    }
    if (urlParam.hasOwnProperty('state')) {
      postParams.state = urlParam.state;
    }
    comreq.userAccountBindExternal(postParams);
  }
})();

// 自动将视频标签高度调整为与视频实际一致
(function () {
  let videoList = $('video');
  for (let i = 0; i < videoList.length; i++) {
    if (videoList[i].poster) {
      $(videoList[i]).attr('height', '')
    }
    $(videoList[i]).on('canplay', function () {
      $(this).css('height', $(this).width() * this.videoHeight / this.videoWidth)
    });
  }
})();

(function () {
  window.getIPv6 = function (data) {
    console.log('getIPv6', data);
    if (/^([\da-fA-F]{1,4}:){6}((25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(25[0-5]|2[0-4]\d|[01]?\d\d?)$|^::([\da-fA-F]{1,4}:){0,4}((25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(25[0-5]|2[0-4]\d|[01]?\d\d?)$|^([\da-fA-F]{1,4}:):([\da-fA-F]{1,4}:){0,3}((25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(25[0-5]|2[0-4]\d|[01]?\d\d?)$|^([\da-fA-F]{1,4}:){2}:([\da-fA-F]{1,4}:){0,2}((25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(25[0-5]|2[0-4]\d|[01]?\d\d?)$|^([\da-fA-F]{1,4}:){3}:([\da-fA-F]{1,4}:){0,1}((25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(25[0-5]|2[0-4]\d|[01]?\d\d?)$|^([\da-fA-F]{1,4}:){4}:((25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(25[0-5]|2[0-4]\d|[01]?\d\d?)$|^([\da-fA-F]{1,4}:){7}[\da-fA-F]{1,4}$|^:((:[\da-fA-F]{1,4}){1,6}|:)$|^[\da-fA-F]{1,4}:((:[\da-fA-F]{1,4}){1,5}|:)$|^([\da-fA-F]{1,4}:){2}((:[\da-fA-F]{1,4}){1,4}|:)$|^([\da-fA-F]{1,4}:){3}((:[\da-fA-F]{1,4}){1,3}|:)$|^([\da-fA-F]{1,4}:){4}((:[\da-fA-F]{1,4}){1,2}|:)$|^([\da-fA-F]{1,4}:){5}:([\da-fA-F]{1,4})?$|^([\da-fA-F]{1,4}:){6}:$/.test(data?.ip)) {
      myTemp.ipv6 = data.ip;
    }
  }
  wj.loadJS("https://api64.ipify.org?format=jsonp&callback=getIPv6", function () {
    console.log('加载ipify')
  })
})();
